// AUTO-GENERATED by `./manage.py generate_ts_enums` — DO NOT EDIT.
//
// Mirrors every `models.Choices` class under `core/models/`. Regenerate after
// adding or removing a member; CI fails when this file drifts from the models.

/** core.models.account.Account.AccountCategory */
export enum AccountCategory {
	LINKED_IN = 0,
	MAIL_RU = 1,
	OUTLOOK = 2,
	GOOGLE = 3,
	GITHUB = 4,
	UNKNOWN = 5,
	YAHOO = 6,
	HOTMAIL = 7,
	REDIFFMAIL = 8,
	YANDEX = 9,
	MAILINATOR = 10,
	PROTIONMAIL = 11,
	OWN_MTA = 12,
}

export const AccountCategoryLabels: Record<AccountCategory, string> = {
	[AccountCategory.LINKED_IN]: "Linked In",
	[AccountCategory.MAIL_RU]: "Mail Ru",
	[AccountCategory.OUTLOOK]: "Outlook",
	[AccountCategory.GOOGLE]: "Google",
	[AccountCategory.GITHUB]: "Github",
	[AccountCategory.UNKNOWN]: "Unknown",
	[AccountCategory.YAHOO]: "Yahoo",
	[AccountCategory.HOTMAIL]: "Hotmail",
	[AccountCategory.REDIFFMAIL]: "Rediffmail",
	[AccountCategory.YANDEX]: "Yandex",
	[AccountCategory.MAILINATOR]: "Mailinator",
	[AccountCategory.PROTIONMAIL]: "Protionmail",
	[AccountCategory.OWN_MTA]: "Own Mta",
};

export const AccountCategoryChoices = [
	{ value: AccountCategory.LINKED_IN, label: "Linked In" },
	{ value: AccountCategory.MAIL_RU, label: "Mail Ru" },
	{ value: AccountCategory.OUTLOOK, label: "Outlook" },
	{ value: AccountCategory.GOOGLE, label: "Google" },
	{ value: AccountCategory.GITHUB, label: "Github" },
	{ value: AccountCategory.UNKNOWN, label: "Unknown" },
	{ value: AccountCategory.YAHOO, label: "Yahoo" },
	{ value: AccountCategory.HOTMAIL, label: "Hotmail" },
	{ value: AccountCategory.REDIFFMAIL, label: "Rediffmail" },
	{ value: AccountCategory.YANDEX, label: "Yandex" },
	{ value: AccountCategory.MAILINATOR, label: "Mailinator" },
	{ value: AccountCategory.PROTIONMAIL, label: "Protionmail" },
	{ value: AccountCategory.OWN_MTA, label: "Own Mta" },
] as const;

/** core.models.assignment.Assignment.AssignmentStatus */
export enum AssignmentStatus {
	PREPARATION = 0,
	ACTIVE = 1,
	INACTIVE = 2,
	DONE_SUCCESS = 3,
	DONE_FAILED = 4,
	PAUSED = 5,
	INCOMING = 6,
	TO_BE_CLOSED = 7,
	SENT_TO_CLIENT = 8,
	DELETED = 9,
}

export const AssignmentStatusLabels: Record<AssignmentStatus, string> = {
	[AssignmentStatus.PREPARATION]: "Preparation",
	[AssignmentStatus.ACTIVE]: "Active",
	[AssignmentStatus.INACTIVE]: "Inactive",
	[AssignmentStatus.DONE_SUCCESS]: "Won",
	[AssignmentStatus.DONE_FAILED]: "Lost",
	[AssignmentStatus.PAUSED]: "Paused",
	[AssignmentStatus.INCOMING]: "Incoming",
	[AssignmentStatus.TO_BE_CLOSED]: "Closing",
	[AssignmentStatus.SENT_TO_CLIENT]: "Sent to Client",
	[AssignmentStatus.DELETED]: "Deleted",
};

export const AssignmentStatusChoices = [
	{ value: AssignmentStatus.PREPARATION, label: "Preparation" },
	{ value: AssignmentStatus.ACTIVE, label: "Active" },
	{ value: AssignmentStatus.INACTIVE, label: "Inactive" },
	{ value: AssignmentStatus.DONE_SUCCESS, label: "Won" },
	{ value: AssignmentStatus.DONE_FAILED, label: "Lost" },
	{ value: AssignmentStatus.PAUSED, label: "Paused" },
	{ value: AssignmentStatus.INCOMING, label: "Incoming" },
	{ value: AssignmentStatus.TO_BE_CLOSED, label: "Closing" },
	{ value: AssignmentStatus.SENT_TO_CLIENT, label: "Sent to Client" },
	{ value: AssignmentStatus.DELETED, label: "Deleted" },
] as const;

/** core.models.assignment.Assignment.AssignmentType */
export enum AssignmentType {
	RECRUITING = 0,
	CONSULTING = 1,
}

export const AssignmentTypeLabels: Record<AssignmentType, string> = {
	[AssignmentType.RECRUITING]: "Recruiting",
	[AssignmentType.CONSULTING]: "Consulting",
};

export const AssignmentTypeChoices = [
	{ value: AssignmentType.RECRUITING, label: "Recruiting" },
	{ value: AssignmentType.CONSULTING, label: "Consulting" },
] as const;

/** core.models.assignment.Assignment.GradingPrompt */
export enum AssignmentGradingPrompt {
	CANDIDATE = "candidate",
	INTRO_BUYER = "intro_buyer",
}

export const AssignmentGradingPromptLabels: Record<AssignmentGradingPrompt, string> = {
	[AssignmentGradingPrompt.CANDIDATE]: "Candidate for the role",
	[AssignmentGradingPrompt.INTRO_BUYER]: "Buyer of recruiting (intro program)",
};

export const AssignmentGradingPromptChoices = [
	{ value: AssignmentGradingPrompt.CANDIDATE, label: "Candidate for the role" },
	{ value: AssignmentGradingPrompt.INTRO_BUYER, label: "Buyer of recruiting (intro program)" },
] as const;

/** core.models.assignment.Assignment.MatchJudge */
export enum AssignmentMatchJudge {
	DEEPINFRA_OSS = "deepinfra_oss",
	GPU_BOX = "gpu_box",
}

export const AssignmentMatchJudgeLabels: Record<AssignmentMatchJudge, string> = {
	[AssignmentMatchJudge.DEEPINFRA_OSS]: "gpt-oss-120b (DeepInfra)",
	[AssignmentMatchJudge.GPU_BOX]: "GPU box (Qwen)",
};

export const AssignmentMatchJudgeChoices = [
	{ value: AssignmentMatchJudge.DEEPINFRA_OSS, label: "gpt-oss-120b (DeepInfra)" },
	{ value: AssignmentMatchJudge.GPU_BOX, label: "GPU box (Qwen)" },
] as const;

/** core.models.assignment_material.AssignmentMaterial.Kind */
export enum AssignmentMaterialKind {
	TEXT = "text",
	PDF = "pdf",
	DOC = "doc",
	IMAGE = "image",
	VIDEO = "video",
	AUDIO = "audio",
}

export const AssignmentMaterialKindLabels: Record<AssignmentMaterialKind, string> = {
	[AssignmentMaterialKind.TEXT]: "Pasted text",
	[AssignmentMaterialKind.PDF]: "PDF",
	[AssignmentMaterialKind.DOC]: "Document",
	[AssignmentMaterialKind.IMAGE]: "Image",
	[AssignmentMaterialKind.VIDEO]: "Video",
	[AssignmentMaterialKind.AUDIO]: "Audio",
};

export const AssignmentMaterialKindChoices = [
	{ value: AssignmentMaterialKind.TEXT, label: "Pasted text" },
	{ value: AssignmentMaterialKind.PDF, label: "PDF" },
	{ value: AssignmentMaterialKind.DOC, label: "Document" },
	{ value: AssignmentMaterialKind.IMAGE, label: "Image" },
	{ value: AssignmentMaterialKind.VIDEO, label: "Video" },
	{ value: AssignmentMaterialKind.AUDIO, label: "Audio" },
] as const;

/** core.models.assignment_material.AssignmentMaterial.Status */
export enum AssignmentMaterialStatus {
	CONVERTING = "converting",
	READY = "ready",
	FAILED = "failed",
}

export const AssignmentMaterialStatusLabels: Record<AssignmentMaterialStatus, string> = {
	[AssignmentMaterialStatus.CONVERTING]: "Converting",
	[AssignmentMaterialStatus.READY]: "Ready",
	[AssignmentMaterialStatus.FAILED]: "Failed",
};

export const AssignmentMaterialStatusChoices = [
	{ value: AssignmentMaterialStatus.CONVERTING, label: "Converting" },
	{ value: AssignmentMaterialStatus.READY, label: "Ready" },
	{ value: AssignmentMaterialStatus.FAILED, label: "Failed" },
] as const;

/** core.models.assistant.AssistantMessage.Role */
export enum AssistantMessageRole {
	USER = "user",
	ASSISTANT = "assistant",
}

export const AssistantMessageRoleLabels: Record<AssistantMessageRole, string> = {
	[AssistantMessageRole.USER]: "User",
	[AssistantMessageRole.ASSISTANT]: "Assistant",
};

export const AssistantMessageRoleChoices = [
	{ value: AssistantMessageRole.USER, label: "User" },
	{ value: AssistantMessageRole.ASSISTANT, label: "Assistant" },
] as const;

/** core.models.attention_item.AttentionKind */
export enum AttentionKind {
	NEEDS_ATTENTION = "needs_attention",
	PITCH_RESPONSE = "pitch_response",
	STALE_CONVERSATION = "stale_conversation",
}

export const AttentionKindLabels: Record<AttentionKind, string> = {
	[AttentionKind.NEEDS_ATTENTION]: "Said something",
	[AttentionKind.PITCH_RESPONSE]: "Answered a pitch",
	[AttentionKind.STALE_CONVERSATION]: "Gone quiet",
};

export const AttentionKindChoices = [
	{ value: AttentionKind.NEEDS_ATTENTION, label: "Said something" },
	{ value: AttentionKind.PITCH_RESPONSE, label: "Answered a pitch" },
	{ value: AttentionKind.STALE_CONVERSATION, label: "Gone quiet" },
] as const;

/** core.models.bot.Bot.InviteStrategy */
export enum BotInviteStrategy {
	RECOMMENDATIONS = "recommendations",
	PROMISCUOUS = "promiscuous",
	FRIENDLY_BOTS = "friendly_bots",
}

export const BotInviteStrategyLabels: Record<BotInviteStrategy, string> = {
	[BotInviteStrategy.RECOMMENDATIONS]: "Recommendations",
	[BotInviteStrategy.PROMISCUOUS]: "Promiscuous",
	[BotInviteStrategy.FRIENDLY_BOTS]: "Friendly Bots",
};

export const BotInviteStrategyChoices = [
	{ value: BotInviteStrategy.RECOMMENDATIONS, label: "Recommendations" },
	{ value: BotInviteStrategy.PROMISCUOUS, label: "Promiscuous" },
	{ value: BotInviteStrategy.FRIENDLY_BOTS, label: "Friendly Bots" },
] as const;

/** core.models.browser_profile.BrowserProfile.Framework */
export enum BrowserProfileFramework {
	MANUAL = "manual",
	SELENIUM = "selenium",
	SELENIUMBASE = "seleniumbase",
	SELENIUMBASE_CDP = "seleniumbase-cdp",
	SELENIUMBASE_PW = "seleniumbase-pw",
	PLAYWRIGHT = "playwright",
	PATCHWRIGHT = "patchwright",
	PYDOLL = "pydoll",
}

export const BrowserProfileFrameworkLabels: Record<BrowserProfileFramework, string> = {
	[BrowserProfileFramework.MANUAL]: "Manual",
	[BrowserProfileFramework.SELENIUM]: "Selenium",
	[BrowserProfileFramework.SELENIUMBASE]: "SeleniumBase",
	[BrowserProfileFramework.SELENIUMBASE_CDP]: "SeleniumBase CDP",
	[BrowserProfileFramework.SELENIUMBASE_PW]: "SeleniumBase Playwright",
	[BrowserProfileFramework.PLAYWRIGHT]: "Playwright",
	[BrowserProfileFramework.PATCHWRIGHT]: "Patchwright",
	[BrowserProfileFramework.PYDOLL]: "Pydoll (CDP)",
};

export const BrowserProfileFrameworkChoices = [
	{ value: BrowserProfileFramework.MANUAL, label: "Manual" },
	{ value: BrowserProfileFramework.SELENIUM, label: "Selenium" },
	{ value: BrowserProfileFramework.SELENIUMBASE, label: "SeleniumBase" },
	{ value: BrowserProfileFramework.SELENIUMBASE_CDP, label: "SeleniumBase CDP" },
	{ value: BrowserProfileFramework.SELENIUMBASE_PW, label: "SeleniumBase Playwright" },
	{ value: BrowserProfileFramework.PLAYWRIGHT, label: "Playwright" },
	{ value: BrowserProfileFramework.PATCHWRIGHT, label: "Patchwright" },
	{ value: BrowserProfileFramework.PYDOLL, label: "Pydoll (CDP)" },
] as const;

/** core.models.captcha_answer.CaptchaAnswer.Labeler */
export enum CaptchaAnswerLabeler {
	MODEL = "model",
	CAPSOLVER = "capsolver",
}

export const CaptchaAnswerLabelerLabels: Record<CaptchaAnswerLabeler, string> = {
	[CaptchaAnswerLabeler.MODEL]: "Model",
	[CaptchaAnswerLabeler.CAPSOLVER]: "Capsolver",
};

export const CaptchaAnswerLabelerChoices = [
	{ value: CaptchaAnswerLabeler.MODEL, label: "Model" },
	{ value: CaptchaAnswerLabeler.CAPSOLVER, label: "Capsolver" },
] as const;

/** core.models.captcha_answer.CaptchaAnswer.Verdict */
export enum CaptchaAnswerVerdict {
	PENDING = "pending",
	ACCEPTED = "accepted",
	INCORRECT = "incorrect",
	NO_VERDICT = "no_verdict",
}

export const CaptchaAnswerVerdictLabels: Record<CaptchaAnswerVerdict, string> = {
	[CaptchaAnswerVerdict.PENDING]: "Pending",
	[CaptchaAnswerVerdict.ACCEPTED]: "Accepted",
	[CaptchaAnswerVerdict.INCORRECT]: "Incorrect",
	[CaptchaAnswerVerdict.NO_VERDICT]: "No Verdict",
};

export const CaptchaAnswerVerdictChoices = [
	{ value: CaptchaAnswerVerdict.PENDING, label: "Pending" },
	{ value: CaptchaAnswerVerdict.ACCEPTED, label: "Accepted" },
	{ value: CaptchaAnswerVerdict.INCORRECT, label: "Incorrect" },
	{ value: CaptchaAnswerVerdict.NO_VERDICT, label: "No Verdict" },
] as const;

/** core.models.channel_resolve_job.ChannelResolveJob.Resolvers */
export enum ChannelResolveJobResolvers {
	ROCKETREACH = 0,
	SNOV = 1,
}

export const ChannelResolveJobResolversLabels: Record<ChannelResolveJobResolvers, string> = {
	[ChannelResolveJobResolvers.ROCKETREACH]: "Rocketreach",
	[ChannelResolveJobResolvers.SNOV]: "Snov",
};

export const ChannelResolveJobResolversChoices = [
	{ value: ChannelResolveJobResolvers.ROCKETREACH, label: "Rocketreach" },
	{ value: ChannelResolveJobResolvers.SNOV, label: "Snov" },
] as const;

/** core.models.choices.GradeConnectBand */
export enum GradeConnectBand {
	REPLIED = 1,
	WORKS = 2,
	WORKED = 3,
	CV = 4,
	COMMENT = 5,
	OPEN_TO_WORK = 6,
	MEETING = 7,
	CALL = 8,
	CUSTOMER_TALKED = 9,
	OTHER = 99,
}

export const GradeConnectBandLabels: Record<GradeConnectBand, string> = {
	[GradeConnectBand.REPLIED]: "Replied",
	[GradeConnectBand.WORKS]: "Current preferred-company employee",
	[GradeConnectBand.WORKED]: "Former preferred-company employee (within 5y)",
	[GradeConnectBand.CV]: "CV uploaded",
	[GradeConnectBand.COMMENT]: "Team comment",
	[GradeConnectBand.OPEN_TO_WORK]: "Open to Work",
	[GradeConnectBand.MEETING]: "Meeting logged",
	[GradeConnectBand.CALL]: "Call logged",
	[GradeConnectBand.CUSTOMER_TALKED]: "Customer talked",
	[GradeConnectBand.OTHER]: "Other",
};

export const GradeConnectBandChoices = [
	{ value: GradeConnectBand.REPLIED, label: "Replied" },
	{ value: GradeConnectBand.WORKS, label: "Current preferred-company employee" },
	{ value: GradeConnectBand.WORKED, label: "Former preferred-company employee (within 5y)" },
	{ value: GradeConnectBand.CV, label: "CV uploaded" },
	{ value: GradeConnectBand.COMMENT, label: "Team comment" },
	{ value: GradeConnectBand.OPEN_TO_WORK, label: "Open to Work" },
	{ value: GradeConnectBand.MEETING, label: "Meeting logged" },
	{ value: GradeConnectBand.CALL, label: "Call logged" },
	{ value: GradeConnectBand.CUSTOMER_TALKED, label: "Customer talked" },
	{ value: GradeConnectBand.OTHER, label: "Other" },
] as const;

/** core.models.choices.GradeConnectMode */
export enum GradeConnectMode {
	CONNECTED = 0,
	UNCONTACTABLE = 1,
	CALLCENTER = 2,
	ALL = 3,
	FREE_FOR_INMAIL = 4,
	GENERIC = 5,
	ML = 6,
	REGEXP = 7,
	ML_REGEXP_COMBO = 8,
	SEARCH = 9,
	LLM_YES = 10,
	SEARCH_AUTO_KEYWORDS = 11,
	LLM_NO = 12,
	ML_VOTES_SOURCE = 17,
	ML_LLM_SOURCE = 18,
	SIM_VOTES_SOURCE = 19,
	SIM_LLM_SOURCE = 20,
	LINKEDIN_SEARCH_SOURCE = 21,
	SEARCH_AUTO_ELASTIC = 22,
	RANDOM_EXPLORATION = 24,
	JOB_APPLICATION = 25,
	CUSTOMER_CONTACTS_SOURCE = 26,
	BOX_YES = 27,
}

export const GradeConnectModeLabels: Record<GradeConnectMode, string> = {
	[GradeConnectMode.CONNECTED]: "Connected",
	[GradeConnectMode.UNCONTACTABLE]: "Uncontactable",
	[GradeConnectMode.CALLCENTER]: "Callcenter",
	[GradeConnectMode.ALL]: "All",
	[GradeConnectMode.FREE_FOR_INMAIL]: "Free For Inmail",
	[GradeConnectMode.GENERIC]: "Generic",
	[GradeConnectMode.ML]: "Ml",
	[GradeConnectMode.REGEXP]: "Regexp",
	[GradeConnectMode.ML_REGEXP_COMBO]: "Ml Regexp Combo",
	[GradeConnectMode.SEARCH]: "Search",
	[GradeConnectMode.LLM_YES]: "Llm Yes",
	[GradeConnectMode.SEARCH_AUTO_KEYWORDS]: "Search Auto Keywords",
	[GradeConnectMode.LLM_NO]: "Llm No",
	[GradeConnectMode.ML_VOTES_SOURCE]: "Ml Votes Source",
	[GradeConnectMode.ML_LLM_SOURCE]: "Ml Llm Source",
	[GradeConnectMode.SIM_VOTES_SOURCE]: "Sim Votes Source",
	[GradeConnectMode.SIM_LLM_SOURCE]: "Sim Llm Source",
	[GradeConnectMode.LINKEDIN_SEARCH_SOURCE]: "Linkedin Search Source",
	[GradeConnectMode.SEARCH_AUTO_ELASTIC]: "Search Auto Elastic",
	[GradeConnectMode.RANDOM_EXPLORATION]: "Random Exploration",
	[GradeConnectMode.JOB_APPLICATION]: "Job Application",
	[GradeConnectMode.CUSTOMER_CONTACTS_SOURCE]: "Customer Contacts Source",
	[GradeConnectMode.BOX_YES]: "Box Yes",
};

export const GradeConnectModeChoices = [
	{ value: GradeConnectMode.CONNECTED, label: "Connected" },
	{ value: GradeConnectMode.UNCONTACTABLE, label: "Uncontactable" },
	{ value: GradeConnectMode.CALLCENTER, label: "Callcenter" },
	{ value: GradeConnectMode.ALL, label: "All" },
	{ value: GradeConnectMode.FREE_FOR_INMAIL, label: "Free For Inmail" },
	{ value: GradeConnectMode.GENERIC, label: "Generic" },
	{ value: GradeConnectMode.ML, label: "Ml" },
	{ value: GradeConnectMode.REGEXP, label: "Regexp" },
	{ value: GradeConnectMode.ML_REGEXP_COMBO, label: "Ml Regexp Combo" },
	{ value: GradeConnectMode.SEARCH, label: "Search" },
	{ value: GradeConnectMode.LLM_YES, label: "Llm Yes" },
	{ value: GradeConnectMode.SEARCH_AUTO_KEYWORDS, label: "Search Auto Keywords" },
	{ value: GradeConnectMode.LLM_NO, label: "Llm No" },
	{ value: GradeConnectMode.ML_VOTES_SOURCE, label: "Ml Votes Source" },
	{ value: GradeConnectMode.ML_LLM_SOURCE, label: "Ml Llm Source" },
	{ value: GradeConnectMode.SIM_VOTES_SOURCE, label: "Sim Votes Source" },
	{ value: GradeConnectMode.SIM_LLM_SOURCE, label: "Sim Llm Source" },
	{ value: GradeConnectMode.LINKEDIN_SEARCH_SOURCE, label: "Linkedin Search Source" },
	{ value: GradeConnectMode.SEARCH_AUTO_ELASTIC, label: "Search Auto Elastic" },
	{ value: GradeConnectMode.RANDOM_EXPLORATION, label: "Random Exploration" },
	{ value: GradeConnectMode.JOB_APPLICATION, label: "Job Application" },
	{ value: GradeConnectMode.CUSTOMER_CONTACTS_SOURCE, label: "Customer Contacts Source" },
	{ value: GradeConnectMode.BOX_YES, label: "Box Yes" },
] as const;

/** core.models.conversation.Conversation.ConversationType */
export enum ConversationType {
	LINKEDIN = 0,
	RECRUITER = 1,
}

export const ConversationTypeLabels: Record<ConversationType, string> = {
	[ConversationType.LINKEDIN]: "Linkedin",
	[ConversationType.RECRUITER]: "Recruiter",
};

export const ConversationTypeChoices = [
	{ value: ConversationType.LINKEDIN, label: "Linkedin" },
	{ value: ConversationType.RECRUITER, label: "Recruiter" },
] as const;

/** core.models.customer_license_period.CustomerLicensePeriod.Currency */
export enum CustomerLicensePeriodCurrency {
	SEK = "SEK",
	EUR = "EUR",
	USD = "USD",
	NOK = "NOK",
	DKK = "DKK",
}

export const CustomerLicensePeriodCurrencyLabels: Record<CustomerLicensePeriodCurrency, string> = {
	[CustomerLicensePeriodCurrency.SEK]: "SEK",
	[CustomerLicensePeriodCurrency.EUR]: "EUR",
	[CustomerLicensePeriodCurrency.USD]: "USD",
	[CustomerLicensePeriodCurrency.NOK]: "NOK",
	[CustomerLicensePeriodCurrency.DKK]: "DKK",
};

export const CustomerLicensePeriodCurrencyChoices = [
	{ value: CustomerLicensePeriodCurrency.SEK, label: "SEK" },
	{ value: CustomerLicensePeriodCurrency.EUR, label: "EUR" },
	{ value: CustomerLicensePeriodCurrency.USD, label: "USD" },
	{ value: CustomerLicensePeriodCurrency.NOK, label: "NOK" },
	{ value: CustomerLicensePeriodCurrency.DKK, label: "DKK" },
] as const;

/** core.models.customer_license_period.CustomerLicensePeriod.Kind */
export enum CustomerLicensePeriodKind {
	TRIAL = "trial",
	LICENSED = "licensed",
}

export const CustomerLicensePeriodKindLabels: Record<CustomerLicensePeriodKind, string> = {
	[CustomerLicensePeriodKind.TRIAL]: "Trial",
	[CustomerLicensePeriodKind.LICENSED]: "Licensed",
};

export const CustomerLicensePeriodKindChoices = [
	{ value: CustomerLicensePeriodKind.TRIAL, label: "Trial" },
	{ value: CustomerLicensePeriodKind.LICENSED, label: "Licensed" },
] as const;

/** core.models.cv_parse.CvParse.Status */
export enum CvParseStatus {
	PARSED = 0,
	CONFIRMED_MATCH = 1,
	CONFIRMED_NEW = 2,
	FAILED = 3,
}

export const CvParseStatusLabels: Record<CvParseStatus, string> = {
	[CvParseStatus.PARSED]: "Parsed",
	[CvParseStatus.CONFIRMED_MATCH]: "Confirmed Match",
	[CvParseStatus.CONFIRMED_NEW]: "Confirmed New",
	[CvParseStatus.FAILED]: "Failed",
};

export const CvParseStatusChoices = [
	{ value: CvParseStatus.PARSED, label: "Parsed" },
	{ value: CvParseStatus.CONFIRMED_MATCH, label: "Confirmed Match" },
	{ value: CvParseStatus.CONFIRMED_NEW, label: "Confirmed New" },
	{ value: CvParseStatus.FAILED, label: "Failed" },
] as const;

/** core.models.deletion_request.DeletionRequest.Status */
export enum DeletionRequestStatus {
	RECEIVED = 0,
	CONFIRMED = 1,
	COMPLETED = 2,
	REJECTED = 3,
}

export const DeletionRequestStatusLabels: Record<DeletionRequestStatus, string> = {
	[DeletionRequestStatus.RECEIVED]: "Received",
	[DeletionRequestStatus.CONFIRMED]: "Confirmed",
	[DeletionRequestStatus.COMPLETED]: "Completed",
	[DeletionRequestStatus.REJECTED]: "Rejected",
};

export const DeletionRequestStatusChoices = [
	{ value: DeletionRequestStatus.RECEIVED, label: "Received" },
	{ value: DeletionRequestStatus.CONFIRMED, label: "Confirmed" },
	{ value: DeletionRequestStatus.COMPLETED, label: "Completed" },
	{ value: DeletionRequestStatus.REJECTED, label: "Rejected" },
] as const;

/** core.models.email_journal_person.EmailJournalPerson.EmailType */
export enum EmailJournalPersonEmailType {
	FROM = 0,
	TO = 1,
	CC = 2,
	BCC = 3,
	ORIGINAL_RECEIVER = 4,
}

export const EmailJournalPersonEmailTypeLabels: Record<EmailJournalPersonEmailType, string> = {
	[EmailJournalPersonEmailType.FROM]: "From",
	[EmailJournalPersonEmailType.TO]: "To",
	[EmailJournalPersonEmailType.CC]: "Cc",
	[EmailJournalPersonEmailType.BCC]: "Bcc",
	[EmailJournalPersonEmailType.ORIGINAL_RECEIVER]: "Original Receiver",
};

export const EmailJournalPersonEmailTypeChoices = [
	{ value: EmailJournalPersonEmailType.FROM, label: "From" },
	{ value: EmailJournalPersonEmailType.TO, label: "To" },
	{ value: EmailJournalPersonEmailType.CC, label: "Cc" },
	{ value: EmailJournalPersonEmailType.BCC, label: "Bcc" },
	{ value: EmailJournalPersonEmailType.ORIGINAL_RECEIVER, label: "Original Receiver" },
] as const;

/** core.models.enums.channels.Channels */
export enum Channels {
	ALL = 0,
	EMAIL = 1,
	LINKEDIN_MESSAGE = 2,
	LINKDIN_INMAIL = 3,
	LINKEDIN_INVITE = 4,
	APPLICANT_ACCEPT = 5,
	APPLICANT_REJECT = 6,
	APPLICANT_REVISIT = 7,
}

export const ChannelsLabels: Record<Channels, string> = {
	[Channels.ALL]: "All",
	[Channels.EMAIL]: "Email",
	[Channels.LINKEDIN_MESSAGE]: "Linkedin Message",
	[Channels.LINKDIN_INMAIL]: "Linkdin Inmail",
	[Channels.LINKEDIN_INVITE]: "Linkedin Invite",
	[Channels.APPLICANT_ACCEPT]: "Applicant Accept",
	[Channels.APPLICANT_REJECT]: "Applicant Reject",
	[Channels.APPLICANT_REVISIT]: "Applicant Revisit",
};

export const ChannelsChoices = [
	{ value: Channels.ALL, label: "All" },
	{ value: Channels.EMAIL, label: "Email" },
	{ value: Channels.LINKEDIN_MESSAGE, label: "Linkedin Message" },
	{ value: Channels.LINKDIN_INMAIL, label: "Linkdin Inmail" },
	{ value: Channels.LINKEDIN_INVITE, label: "Linkedin Invite" },
	{ value: Channels.APPLICANT_ACCEPT, label: "Applicant Accept" },
	{ value: Channels.APPLICANT_REJECT, label: "Applicant Reject" },
	{ value: Channels.APPLICANT_REVISIT, label: "Applicant Revisit" },
] as const;

/** core.models.enums.pitch_origin.PitchOrigin */
export enum PitchOrigin {
	TEMPLATE = "template",
	AI = "ai",
	MANUAL = "manual",
}

export const PitchOriginLabels: Record<PitchOrigin, string> = {
	[PitchOrigin.TEMPLATE]: "Template",
	[PitchOrigin.AI]: "Ai",
	[PitchOrigin.MANUAL]: "Manual",
};

export const PitchOriginChoices = [
	{ value: PitchOrigin.TEMPLATE, label: "Template" },
	{ value: PitchOrigin.AI, label: "Ai" },
	{ value: PitchOrigin.MANUAL, label: "Manual" },
] as const;

/** core.models.geosearchtype.GeoSearchType.Verdict */
export enum GeoSearchTypeVerdict {
	CONFIRMED = "confirmed",
	REVIEW = "review",
	NO_HIT = "no_hit",
}

export const GeoSearchTypeVerdictLabels: Record<GeoSearchTypeVerdict, string> = {
	[GeoSearchTypeVerdict.CONFIRMED]: "Confirmed",
	[GeoSearchTypeVerdict.REVIEW]: "Review",
	[GeoSearchTypeVerdict.NO_HIT]: "No Hit",
};

export const GeoSearchTypeVerdictChoices = [
	{ value: GeoSearchTypeVerdict.CONFIRMED, label: "Confirmed" },
	{ value: GeoSearchTypeVerdict.REVIEW, label: "Review" },
	{ value: GeoSearchTypeVerdict.NO_HIT, label: "No Hit" },
] as const;

/** core.models.gmaps_geocode_cache.GmapsGeoCodeCache.Source */
export enum GmapsGeoCodeCacheSource {
	GOOGLE_MAPS = 0,
	BING = 1,
	OPENSTREETMAP = 2,
}

export const GmapsGeoCodeCacheSourceLabels: Record<GmapsGeoCodeCacheSource, string> = {
	[GmapsGeoCodeCacheSource.GOOGLE_MAPS]: "Google Maps",
	[GmapsGeoCodeCacheSource.BING]: "Bing",
	[GmapsGeoCodeCacheSource.OPENSTREETMAP]: "Openstreetmap",
};

export const GmapsGeoCodeCacheSourceChoices = [
	{ value: GmapsGeoCodeCacheSource.GOOGLE_MAPS, label: "Google Maps" },
	{ value: GmapsGeoCodeCacheSource.BING, label: "Bing" },
	{ value: GmapsGeoCodeCacheSource.OPENSTREETMAP, label: "Openstreetmap" },
] as const;

/** core.models.hosted_tenant_suspension.HostedTenantSuspension.Reason */
export enum HostedTenantSuspensionReason {
	COMPLAINT_RATE = "complaint_rate",
	BOUNCE_RATE = "bounce_rate",
	MANUAL = "manual",
}

export const HostedTenantSuspensionReasonLabels: Record<HostedTenantSuspensionReason, string> = {
	[HostedTenantSuspensionReason.COMPLAINT_RATE]: "Complaint rate",
	[HostedTenantSuspensionReason.BOUNCE_RATE]: "Bounce rate",
	[HostedTenantSuspensionReason.MANUAL]: "Manual",
};

export const HostedTenantSuspensionReasonChoices = [
	{ value: HostedTenantSuspensionReason.COMPLAINT_RATE, label: "Complaint rate" },
	{ value: HostedTenantSuspensionReason.BOUNCE_RATE, label: "Bounce rate" },
	{ value: HostedTenantSuspensionReason.MANUAL, label: "Manual" },
] as const;

/** core.models.hosted_unsubscribe.HostedUnsubscribe.Reason */
export enum HostedUnsubscribeReason {
	ONE_CLICK = "one_click",
	COMPLAINT = "complaint",
	HARD_BOUNCE = "hard_bounce",
	MANUAL = "manual",
}

export const HostedUnsubscribeReasonLabels: Record<HostedUnsubscribeReason, string> = {
	[HostedUnsubscribeReason.ONE_CLICK]: "One-click",
	[HostedUnsubscribeReason.COMPLAINT]: "Complaint",
	[HostedUnsubscribeReason.HARD_BOUNCE]: "Hard bounce",
	[HostedUnsubscribeReason.MANUAL]: "Manual",
};

export const HostedUnsubscribeReasonChoices = [
	{ value: HostedUnsubscribeReason.ONE_CLICK, label: "One-click" },
	{ value: HostedUnsubscribeReason.COMPLAINT, label: "Complaint" },
	{ value: HostedUnsubscribeReason.HARD_BOUNCE, label: "Hard bounce" },
	{ value: HostedUnsubscribeReason.MANUAL, label: "Manual" },
] as const;

/** core.models.intro_request.IntroRequestStatus */
export enum IntroRequestStatus {
	PENDING = "pending",
	SENT = "sent",
	REPLIED = "replied",
	CLOSED = "closed",
	CONVERTED = "converted",
	SKIPPED = "skipped",
}

export const IntroRequestStatusLabels: Record<IntroRequestStatus, string> = {
	[IntroRequestStatus.PENDING]: "Pending",
	[IntroRequestStatus.SENT]: "Sent",
	[IntroRequestStatus.REPLIED]: "Replied",
	[IntroRequestStatus.CLOSED]: "Closed",
	[IntroRequestStatus.CONVERTED]: "Converted",
	[IntroRequestStatus.SKIPPED]: "Skipped",
};

export const IntroRequestStatusChoices = [
	{ value: IntroRequestStatus.PENDING, label: "Pending" },
	{ value: IntroRequestStatus.SENT, label: "Sent" },
	{ value: IntroRequestStatus.REPLIED, label: "Replied" },
	{ value: IntroRequestStatus.CLOSED, label: "Closed" },
	{ value: IntroRequestStatus.CONVERTED, label: "Converted" },
	{ value: IntroRequestStatus.SKIPPED, label: "Skipped" },
] as const;

/** core.models.ip_addresses_classification.IpAddressesClassification.ServiceType */
export enum IpAddressesClassificationServiceType {
	CREATE_ACCOUNT = 0,
	IP_QUALITY_CHECK = 1,
}

export const IpAddressesClassificationServiceTypeLabels: Record<IpAddressesClassificationServiceType, string> = {
	[IpAddressesClassificationServiceType.CREATE_ACCOUNT]: "Create Account",
	[IpAddressesClassificationServiceType.IP_QUALITY_CHECK]: "Ip Quality Check",
};

export const IpAddressesClassificationServiceTypeChoices = [
	{ value: IpAddressesClassificationServiceType.CREATE_ACCOUNT, label: "Create Account" },
	{ value: IpAddressesClassificationServiceType.IP_QUALITY_CHECK, label: "Ip Quality Check" },
] as const;

/** core.models.job_ad.JobAd.ApplicationRequirement */
export enum JobAdApplicationRequirement {
	NONE = "NONE",
	COVER_LETTER = "COVER_LETTER",
	QUESTIONS = "QUESTIONS",
}

export const JobAdApplicationRequirementLabels: Record<JobAdApplicationRequirement, string> = {
	[JobAdApplicationRequirement.NONE]: "None",
	[JobAdApplicationRequirement.COVER_LETTER]: "Cover Letter",
	[JobAdApplicationRequirement.QUESTIONS]: "Questions",
};

export const JobAdApplicationRequirementChoices = [
	{ value: JobAdApplicationRequirement.NONE, label: "None" },
	{ value: JobAdApplicationRequirement.COVER_LETTER, label: "Cover Letter" },
	{ value: JobAdApplicationRequirement.QUESTIONS, label: "Questions" },
] as const;

/** core.models.job_ad.JobAd.EmploymentType */
export enum JobAdEmploymentType {
	FULL_TIME = "FULL_TIME",
	PART_TIME = "PART_TIME",
	CONTRACTOR = "CONTRACTOR",
	TEMPORARY = "TEMPORARY",
	INTERN = "INTERN",
	OTHER = "OTHER",
}

export const JobAdEmploymentTypeLabels: Record<JobAdEmploymentType, string> = {
	[JobAdEmploymentType.FULL_TIME]: "Full Time",
	[JobAdEmploymentType.PART_TIME]: "Part Time",
	[JobAdEmploymentType.CONTRACTOR]: "Contractor",
	[JobAdEmploymentType.TEMPORARY]: "Temporary",
	[JobAdEmploymentType.INTERN]: "Intern",
	[JobAdEmploymentType.OTHER]: "Other",
};

export const JobAdEmploymentTypeChoices = [
	{ value: JobAdEmploymentType.FULL_TIME, label: "Full Time" },
	{ value: JobAdEmploymentType.PART_TIME, label: "Part Time" },
	{ value: JobAdEmploymentType.CONTRACTOR, label: "Contractor" },
	{ value: JobAdEmploymentType.TEMPORARY, label: "Temporary" },
	{ value: JobAdEmploymentType.INTERN, label: "Intern" },
	{ value: JobAdEmploymentType.OTHER, label: "Other" },
] as const;

/** core.models.job_ad.JobAd.PlatsbankenStatus */
export enum JobAdPlatsbankenStatus {
	NOT_SENT = "NOT_SENT",
	LISTED = "LISTED",
	UNPUBLISHED = "UNPUBLISHED",
	REFUSED = "REFUSED",
	NO_CONSENT = "NO_CONSENT",
}

export const JobAdPlatsbankenStatusLabels: Record<JobAdPlatsbankenStatus, string> = {
	[JobAdPlatsbankenStatus.NOT_SENT]: "Not Sent",
	[JobAdPlatsbankenStatus.LISTED]: "Listed",
	[JobAdPlatsbankenStatus.UNPUBLISHED]: "Unpublished",
	[JobAdPlatsbankenStatus.REFUSED]: "Refused",
	[JobAdPlatsbankenStatus.NO_CONSENT]: "No Consent",
};

export const JobAdPlatsbankenStatusChoices = [
	{ value: JobAdPlatsbankenStatus.NOT_SENT, label: "Not Sent" },
	{ value: JobAdPlatsbankenStatus.LISTED, label: "Listed" },
	{ value: JobAdPlatsbankenStatus.UNPUBLISHED, label: "Unpublished" },
	{ value: JobAdPlatsbankenStatus.REFUSED, label: "Refused" },
	{ value: JobAdPlatsbankenStatus.NO_CONSENT, label: "No Consent" },
] as const;

/** core.models.job_ad.JobAd.SalaryPeriod */
export enum JobAdSalaryPeriod {
	HOUR = "HOUR",
	MONTH = "MONTH",
	YEAR = "YEAR",
}

export const JobAdSalaryPeriodLabels: Record<JobAdSalaryPeriod, string> = {
	[JobAdSalaryPeriod.HOUR]: "Hour",
	[JobAdSalaryPeriod.MONTH]: "Month",
	[JobAdSalaryPeriod.YEAR]: "Year",
};

export const JobAdSalaryPeriodChoices = [
	{ value: JobAdSalaryPeriod.HOUR, label: "Hour" },
	{ value: JobAdSalaryPeriod.MONTH, label: "Month" },
	{ value: JobAdSalaryPeriod.YEAR, label: "Year" },
] as const;

/** core.models.job_ad_brand.JobAdBrand.SiteBuilder */
export enum JobAdBrandSiteBuilder {
	UNKNOWN = "UNKNOWN",
	ONE_COM = "ONE_COM",
	WIX = "WIX",
	SQUARESPACE = "SQUARESPACE",
	WORDPRESS = "WORDPRESS",
	WEBFLOW = "WEBFLOW",
	OTHER = "OTHER",
}

export const JobAdBrandSiteBuilderLabels: Record<JobAdBrandSiteBuilder, string> = {
	[JobAdBrandSiteBuilder.UNKNOWN]: "Unknown",
	[JobAdBrandSiteBuilder.ONE_COM]: "One Com",
	[JobAdBrandSiteBuilder.WIX]: "Wix",
	[JobAdBrandSiteBuilder.SQUARESPACE]: "Squarespace",
	[JobAdBrandSiteBuilder.WORDPRESS]: "Wordpress",
	[JobAdBrandSiteBuilder.WEBFLOW]: "Webflow",
	[JobAdBrandSiteBuilder.OTHER]: "Other",
};

export const JobAdBrandSiteBuilderChoices = [
	{ value: JobAdBrandSiteBuilder.UNKNOWN, label: "Unknown" },
	{ value: JobAdBrandSiteBuilder.ONE_COM, label: "One Com" },
	{ value: JobAdBrandSiteBuilder.WIX, label: "Wix" },
	{ value: JobAdBrandSiteBuilder.SQUARESPACE, label: "Squarespace" },
	{ value: JobAdBrandSiteBuilder.WORDPRESS, label: "Wordpress" },
	{ value: JobAdBrandSiteBuilder.WEBFLOW, label: "Webflow" },
	{ value: JobAdBrandSiteBuilder.OTHER, label: "Other" },
] as const;

/** core.models.job_application.JobApplication.Status */
export enum JobApplicationStatus {
	RECEIVED = 0,
	PROCESSED = 1,
	FAILED = 2,
}

export const JobApplicationStatusLabels: Record<JobApplicationStatus, string> = {
	[JobApplicationStatus.RECEIVED]: "Received",
	[JobApplicationStatus.PROCESSED]: "Processed",
	[JobApplicationStatus.FAILED]: "Failed",
};

export const JobApplicationStatusChoices = [
	{ value: JobApplicationStatus.RECEIVED, label: "Received" },
	{ value: JobApplicationStatus.PROCESSED, label: "Processed" },
	{ value: JobApplicationStatus.FAILED, label: "Failed" },
] as const;

/** core.models.jobtech_concept.JobTechConcept.ConceptType */
export enum JobTechConceptConceptType {
	OCCUPATION_NAME = "occupation-name",
	MUNICIPALITY = "municipality",
}

export const JobTechConceptConceptTypeLabels: Record<JobTechConceptConceptType, string> = {
	[JobTechConceptConceptType.OCCUPATION_NAME]: "Occupation Name",
	[JobTechConceptConceptType.MUNICIPALITY]: "Municipality",
};

export const JobTechConceptConceptTypeChoices = [
	{ value: JobTechConceptConceptType.OCCUPATION_NAME, label: "Occupation Name" },
	{ value: JobTechConceptConceptType.MUNICIPALITY, label: "Municipality" },
] as const;

/** core.models.jobylon_candidate.JobylonCandidate.Origin */
export enum JobylonCandidateOrigin {
	SOURCED = "sourced",
	APPLIED = "applied",
}

export const JobylonCandidateOriginLabels: Record<JobylonCandidateOrigin, string> = {
	[JobylonCandidateOrigin.SOURCED]: "Sourced",
	[JobylonCandidateOrigin.APPLIED]: "Applied",
};

export const JobylonCandidateOriginChoices = [
	{ value: JobylonCandidateOrigin.SOURCED, label: "Sourced" },
	{ value: JobylonCandidateOrigin.APPLIED, label: "Applied" },
] as const;

/** core.models.jobylon_webhook_event.JobylonWebhookEvent.Track */
export enum JobylonWebhookEventTrack {
	PUSH = "push",
	PARTNER = "partner",
}

export const JobylonWebhookEventTrackLabels: Record<JobylonWebhookEventTrack, string> = {
	[JobylonWebhookEventTrack.PUSH]: "Push",
	[JobylonWebhookEventTrack.PARTNER]: "Partner",
};

export const JobylonWebhookEventTrackChoices = [
	{ value: JobylonWebhookEventTrack.PUSH, label: "Push" },
	{ value: JobylonWebhookEventTrack.PARTNER, label: "Partner" },
] as const;

/** core.models.json_request_cache.JsonRequestCache.HTTPMethods */
export enum JsonRequestCacheHTTPMethods {
	GET = 0,
	HEAD = 1,
	POST = 2,
	PUT = 3,
	DELETE = 4,
	CONNECT = 5,
	OPTIONS = 6,
	TRACE = 7,
	PATCH = 8,
}

export const JsonRequestCacheHTTPMethodsLabels: Record<JsonRequestCacheHTTPMethods, string> = {
	[JsonRequestCacheHTTPMethods.GET]: "Get",
	[JsonRequestCacheHTTPMethods.HEAD]: "Head",
	[JsonRequestCacheHTTPMethods.POST]: "Post",
	[JsonRequestCacheHTTPMethods.PUT]: "Put",
	[JsonRequestCacheHTTPMethods.DELETE]: "Delete",
	[JsonRequestCacheHTTPMethods.CONNECT]: "Connect",
	[JsonRequestCacheHTTPMethods.OPTIONS]: "Options",
	[JsonRequestCacheHTTPMethods.TRACE]: "Trace",
	[JsonRequestCacheHTTPMethods.PATCH]: "Patch",
};

export const JsonRequestCacheHTTPMethodsChoices = [
	{ value: JsonRequestCacheHTTPMethods.GET, label: "Get" },
	{ value: JsonRequestCacheHTTPMethods.HEAD, label: "Head" },
	{ value: JsonRequestCacheHTTPMethods.POST, label: "Post" },
	{ value: JsonRequestCacheHTTPMethods.PUT, label: "Put" },
	{ value: JsonRequestCacheHTTPMethods.DELETE, label: "Delete" },
	{ value: JsonRequestCacheHTTPMethods.CONNECT, label: "Connect" },
	{ value: JsonRequestCacheHTTPMethods.OPTIONS, label: "Options" },
	{ value: JsonRequestCacheHTTPMethods.TRACE, label: "Trace" },
	{ value: JsonRequestCacheHTTPMethods.PATCH, label: "Patch" },
] as const;

/** core.models.license_pricing.LicenseLevel.BindingMonths */
export enum LicenseLevelBindingMonths {
	ONE_MONTH = 1,
	THREE_MONTHS = 3,
	TWELVE_MONTHS = 12,
}

export const LicenseLevelBindingMonthsLabels: Record<LicenseLevelBindingMonths, string> = {
	[LicenseLevelBindingMonths.ONE_MONTH]: "1 month",
	[LicenseLevelBindingMonths.THREE_MONTHS]: "3 months",
	[LicenseLevelBindingMonths.TWELVE_MONTHS]: "1 year",
};

export const LicenseLevelBindingMonthsChoices = [
	{ value: LicenseLevelBindingMonths.ONE_MONTH, label: "1 month" },
	{ value: LicenseLevelBindingMonths.THREE_MONTHS, label: "3 months" },
	{ value: LicenseLevelBindingMonths.TWELVE_MONTHS, label: "1 year" },
] as const;

/** core.models.message_attachment.MessageAttachment.Status */
export enum MessageAttachmentStatus {
	PENDING = "pending",
	TO_REVIEW = "to_review",
	LINKED = "linked",
	NOT_CV = "not_cv",
	UNAVAILABLE = "unavailable",
	DISMISSED = "dismissed",
}

export const MessageAttachmentStatusLabels: Record<MessageAttachmentStatus, string> = {
	[MessageAttachmentStatus.PENDING]: "Not analysed",
	[MessageAttachmentStatus.TO_REVIEW]: "To review",
	[MessageAttachmentStatus.LINKED]: "Linked",
	[MessageAttachmentStatus.NOT_CV]: "Not a CV",
	[MessageAttachmentStatus.UNAVAILABLE]: "Unavailable",
	[MessageAttachmentStatus.DISMISSED]: "Dismissed",
};

export const MessageAttachmentStatusChoices = [
	{ value: MessageAttachmentStatus.PENDING, label: "Not analysed" },
	{ value: MessageAttachmentStatus.TO_REVIEW, label: "To review" },
	{ value: MessageAttachmentStatus.LINKED, label: "Linked" },
	{ value: MessageAttachmentStatus.NOT_CV, label: "Not a CV" },
	{ value: MessageAttachmentStatus.UNAVAILABLE, label: "Unavailable" },
	{ value: MessageAttachmentStatus.DISMISSED, label: "Dismissed" },
] as const;

/** core.models.person_email.PersonEmail.Category */
export enum PersonEmailCategory {
	UNKNOWN = 0,
	PERSONAL = 1,
	PROFESSIONAL = 2,
}

export const PersonEmailCategoryLabels: Record<PersonEmailCategory, string> = {
	[PersonEmailCategory.UNKNOWN]: "Unknown",
	[PersonEmailCategory.PERSONAL]: "Personal",
	[PersonEmailCategory.PROFESSIONAL]: "Professional",
};

export const PersonEmailCategoryChoices = [
	{ value: PersonEmailCategory.UNKNOWN, label: "Unknown" },
	{ value: PersonEmailCategory.PERSONAL, label: "Personal" },
	{ value: PersonEmailCategory.PROFESSIONAL, label: "Professional" },
] as const;

/** core.models.person_email.PersonEmail.SmtpStatus */
export enum PersonEmailSmtpStatus {
	UNKNOWN = 0,
	OK = 1,
	REJECTED = 2,
	POLICY_BLOCKED = 3,
}

export const PersonEmailSmtpStatusLabels: Record<PersonEmailSmtpStatus, string> = {
	[PersonEmailSmtpStatus.UNKNOWN]: "Unknown",
	[PersonEmailSmtpStatus.OK]: "Ok",
	[PersonEmailSmtpStatus.REJECTED]: "Rejected",
	[PersonEmailSmtpStatus.POLICY_BLOCKED]: "Policy Blocked",
};

export const PersonEmailSmtpStatusChoices = [
	{ value: PersonEmailSmtpStatus.UNKNOWN, label: "Unknown" },
	{ value: PersonEmailSmtpStatus.OK, label: "Ok" },
	{ value: PersonEmailSmtpStatus.REJECTED, label: "Rejected" },
	{ value: PersonEmailSmtpStatus.POLICY_BLOCKED, label: "Policy Blocked" },
] as const;

/** core.models.person_email.PersonEmail.Source */
export enum PersonEmailSource {
	LINKEDIN = 0,
	ROCKETREACH = 1,
	MANUAL = 2,
	LINKEDIN_IMPORTER = 3,
	SNOV = 4,
	DROPCONTACT = 5,
	GMAIL_THREAD_RESOLVE = 6,
	JOBYLON = 7,
	THREAD_REPLY = 8,
	CV_HARVEST = 9,
}

export const PersonEmailSourceLabels: Record<PersonEmailSource, string> = {
	[PersonEmailSource.LINKEDIN]: "Linkedin",
	[PersonEmailSource.ROCKETREACH]: "Rocketreach",
	[PersonEmailSource.MANUAL]: "Manual",
	[PersonEmailSource.LINKEDIN_IMPORTER]: "Linkedin Importer",
	[PersonEmailSource.SNOV]: "Snov",
	[PersonEmailSource.DROPCONTACT]: "Dropcontact",
	[PersonEmailSource.GMAIL_THREAD_RESOLVE]: "Gmail Thread Resolve",
	[PersonEmailSource.JOBYLON]: "Jobylon",
	[PersonEmailSource.THREAD_REPLY]: "Thread Reply",
	[PersonEmailSource.CV_HARVEST]: "Cv Harvest",
};

export const PersonEmailSourceChoices = [
	{ value: PersonEmailSource.LINKEDIN, label: "Linkedin" },
	{ value: PersonEmailSource.ROCKETREACH, label: "Rocketreach" },
	{ value: PersonEmailSource.MANUAL, label: "Manual" },
	{ value: PersonEmailSource.LINKEDIN_IMPORTER, label: "Linkedin Importer" },
	{ value: PersonEmailSource.SNOV, label: "Snov" },
	{ value: PersonEmailSource.DROPCONTACT, label: "Dropcontact" },
	{ value: PersonEmailSource.GMAIL_THREAD_RESOLVE, label: "Gmail Thread Resolve" },
	{ value: PersonEmailSource.JOBYLON, label: "Jobylon" },
	{ value: PersonEmailSource.THREAD_REPLY, label: "Thread Reply" },
	{ value: PersonEmailSource.CV_HARVEST, label: "Cv Harvest" },
] as const;

/** core.models.person_phonenumber.PersonPhonenumber.Source */
export enum PersonPhonenumberSource {
	LINKEDIN = 0,
	HITTA_SE = 1,
	RATSIT = 2,
	ENIRO = 3,
	MININFO = 4,
	MRKOLL = 5,
	MANUAL = 6,
	JOBYLON = 7,
}

export const PersonPhonenumberSourceLabels: Record<PersonPhonenumberSource, string> = {
	[PersonPhonenumberSource.LINKEDIN]: "Linkedin",
	[PersonPhonenumberSource.HITTA_SE]: "Hitta Se",
	[PersonPhonenumberSource.RATSIT]: "Ratsit",
	[PersonPhonenumberSource.ENIRO]: "Eniro",
	[PersonPhonenumberSource.MININFO]: "Mininfo",
	[PersonPhonenumberSource.MRKOLL]: "Mrkoll",
	[PersonPhonenumberSource.MANUAL]: "Manual",
	[PersonPhonenumberSource.JOBYLON]: "Jobylon",
};

export const PersonPhonenumberSourceChoices = [
	{ value: PersonPhonenumberSource.LINKEDIN, label: "Linkedin" },
	{ value: PersonPhonenumberSource.HITTA_SE, label: "Hitta Se" },
	{ value: PersonPhonenumberSource.RATSIT, label: "Ratsit" },
	{ value: PersonPhonenumberSource.ENIRO, label: "Eniro" },
	{ value: PersonPhonenumberSource.MININFO, label: "Mininfo" },
	{ value: PersonPhonenumberSource.MRKOLL, label: "Mrkoll" },
	{ value: PersonPhonenumberSource.MANUAL, label: "Manual" },
	{ value: PersonPhonenumberSource.JOBYLON, label: "Jobylon" },
] as const;

/** core.models.postfix_delivery_event.PostfixDeliveryEvent.Status */
export enum PostfixDeliveryEventStatus {
	SENT = 1,
	BOUNCED = 2,
	DEFERRED = 3,
	EXPIRED = 4,
	QUEUED = 5,
}

export const PostfixDeliveryEventStatusLabels: Record<PostfixDeliveryEventStatus, string> = {
	[PostfixDeliveryEventStatus.SENT]: "sent",
	[PostfixDeliveryEventStatus.BOUNCED]: "bounced",
	[PostfixDeliveryEventStatus.DEFERRED]: "deferred",
	[PostfixDeliveryEventStatus.EXPIRED]: "expired",
	[PostfixDeliveryEventStatus.QUEUED]: "queued",
};

export const PostfixDeliveryEventStatusChoices = [
	{ value: PostfixDeliveryEventStatus.SENT, label: "sent" },
	{ value: PostfixDeliveryEventStatus.BOUNCED, label: "bounced" },
	{ value: PostfixDeliveryEventStatus.DEFERRED, label: "deferred" },
	{ value: PostfixDeliveryEventStatus.EXPIRED, label: "expired" },
	{ value: PostfixDeliveryEventStatus.QUEUED, label: "queued" },
] as const;

/** core.models.prod_deploy.ProdDeploy.Kind */
export enum ProdDeployKind {
	DEPLOY = "deploy",
	SHA = "sha",
	ROLLBACK = "rollback",
	SEEDED = "seeded",
}

export const ProdDeployKindLabels: Record<ProdDeployKind, string> = {
	[ProdDeployKind.DEPLOY]: "deploy",
	[ProdDeployKind.SHA]: "sha",
	[ProdDeployKind.ROLLBACK]: "rollback",
	[ProdDeployKind.SEEDED]: "seeded",
};

export const ProdDeployKindChoices = [
	{ value: ProdDeployKind.DEPLOY, label: "deploy" },
	{ value: ProdDeployKind.SHA, label: "sha" },
	{ value: ProdDeployKind.ROLLBACK, label: "rollback" },
	{ value: ProdDeployKind.SEEDED, label: "seeded" },
] as const;

/** core.models.profile_fetch_batch.ProfileFetchBatch.Status */
export enum ProfileFetchBatchStatus {
	IN_PROGRESS = "in_progress",
	COMPLETED = "completed",
	FAILED = "failed",
}

export const ProfileFetchBatchStatusLabels: Record<ProfileFetchBatchStatus, string> = {
	[ProfileFetchBatchStatus.IN_PROGRESS]: "In Progress",
	[ProfileFetchBatchStatus.COMPLETED]: "Completed",
	[ProfileFetchBatchStatus.FAILED]: "Failed",
};

export const ProfileFetchBatchStatusChoices = [
	{ value: ProfileFetchBatchStatus.IN_PROGRESS, label: "In Progress" },
	{ value: ProfileFetchBatchStatus.COMPLETED, label: "Completed" },
	{ value: ProfileFetchBatchStatus.FAILED, label: "Failed" },
] as const;

/** core.models.profile_json_binary.ProfileJsonBinary.ProfileType */
export enum ProfileJsonBinaryProfileType {
	PROFILE = 0,
	SKILLS = 1,
	CONNECTIONS = 2,
	CONTACTINFO = 3,
	SKILLS_CATEGORY = 4,
	POSITIONS = 5,
	PATENTS = 6,
	EDUCATIONS = 7,
	ORGANIZATIONS = 8,
	PROJECTS = 9,
	LANGUAGES = 10,
	CERTIFICATIONS = 11,
	COURSES = 12,
	HONORS = 13,
	VOLUNTEEREXPERIENCES = 14,
	VOLUNTEERCAUSES = 15,
	PUBLICATIONS = 16,
	POSITIONGROUPS = 17,
	BROWSEMAPWITHDISTANCE = 18,
	TALENTRECIPIENTINMAILCOSTINFO = 19,
	INTERESTS = 20,
	GROUPLISTINGPAGE = 21,
	COMPANY = 22,
	SEARCH = 23,
	JOB_SEARCH = 24,
	JOB = 25,
	HIRING = 26,
	GEOSEARCHTYPE = 27,
	DASH_PROFILE = 28,
	PROFILE_TNG = 29,
	PROFILE_IDENTITY_FROM_DEFERRED_CARDS = 30,
	PROFILE_INITIAL_CARDS_GRAPHQL = 70,
	PROFILE_DEFERRED_CARDS_GRAPHQL = 71,
	DASH_PROFILE_GRAPHQL = 72,
	DASH_PROFILE_SUPPLEMENTARY_GRAPHQL = 73,
	PROFILE_RIGHT_RAIL_CARDS_GRAPHQL = 74,
	PROFILE_HTML = 75,
	EXPERIENCE_GRAPHQL = 80,
	EDUCATION_GRAPHQL = 81,
	SKILLS_GRAPHQL = 82,
	LANGUAGES_GRAPHQL = 83,
	CERTIFICATIONS_GRAPHQL = 84,
	VOLUNTEERING_GRAPHQL = 85,
	RECOMMENDATIONS_GRAPHQL = 86,
	PROJECTS_GRAPHQL = 87,
	PUBLICATIONS_GRAPHQL = 88,
	HONORS_AWARDS_GRAPHQL = 89,
	PATENTS_GRAPHQL = 90,
	COURSES_GRAPHQL = 91,
	ORGANIZATIONS_GRAPHQL = 92,
	GROUPS_GRAPHQL = 93,
	NETWORK_PROXIMITY_GRAPHQL = 94,
	INTERESTS_GRAPHQL = 95,
	VOYAGERMESSAGINGDASHCOMPOSEOPTIONS = 96,
	CONTACTINFO_TNG = 97,
	CONVERSATIONS = 98,
	CONVERSATION_MESSAGES = 99,
	INVITATIONS = 100,
	CONVERSATIONS_GRAPHQL = 110,
	CONVERSATION_MESSAGES_GRAPHQL = 111,
	TALENT_CONVERSATION = 112,
	TALENT_SEARCH = 115,
	TALENT_MAILBOX = 117,
	GROUP_MEMBERSHIPS = 113,
	CURATED_CONTACTS = 114,
	AERO_STATIC = 116,
	ME = 118,
	IWE_RESTRICTION = 119,
	FLAGSHIP_WEB = 120,
	LINKEDIN_HOMEPAGE = 121,
	LITMS = 122,
	RECOMMENDATIONS = 123,
	ME_PROFILE = 124,
	SKILLS_RSC = 125,
	EXPERIENCE_RSC = 126,
	EDUCATION_RSC = 127,
	RECOMMENDATIONS_RSC = 128,
	PROJECTS_RSC = 129,
	PUBLICATIONS_RSC = 130,
	HONORS_AWARDS_RSC = 131,
	COURSES_RSC = 132,
	GROUPS_RSC = 133,
	PATENTS_RSC = 134,
	SKILL_ASSOCIATIONS_RSC = 135,
	VOLUNTEERING_RSC = 136,
	LANGUAGES_RSC = 137,
	ORGANIZATIONS_RSC = 138,
	CERTIFICATIONS_RSC = 139,
	RECOMMENDATIONS_GIVEN_RSC = 140,
	PROFILE_DOCUMENT_RSC = 141,
	PROFILE_CARDS_RSC = 142,
	PROFILE_ACTIVITY_RSC = 143,
	BROWSEMAP_RSC = 144,
	COMPANY_PAGE = 145,
}

export const ProfileJsonBinaryProfileTypeLabels: Record<ProfileJsonBinaryProfileType, string> = {
	[ProfileJsonBinaryProfileType.PROFILE]: "Profile",
	[ProfileJsonBinaryProfileType.SKILLS]: "Skills",
	[ProfileJsonBinaryProfileType.CONNECTIONS]: "Connections",
	[ProfileJsonBinaryProfileType.CONTACTINFO]: "Contactinfo",
	[ProfileJsonBinaryProfileType.SKILLS_CATEGORY]: "Skills Category",
	[ProfileJsonBinaryProfileType.POSITIONS]: "Positions",
	[ProfileJsonBinaryProfileType.PATENTS]: "Patents",
	[ProfileJsonBinaryProfileType.EDUCATIONS]: "Educations",
	[ProfileJsonBinaryProfileType.ORGANIZATIONS]: "Organizations",
	[ProfileJsonBinaryProfileType.PROJECTS]: "Projects",
	[ProfileJsonBinaryProfileType.LANGUAGES]: "Languages",
	[ProfileJsonBinaryProfileType.CERTIFICATIONS]: "Certifications",
	[ProfileJsonBinaryProfileType.COURSES]: "Courses",
	[ProfileJsonBinaryProfileType.HONORS]: "Honors",
	[ProfileJsonBinaryProfileType.VOLUNTEEREXPERIENCES]: "Volunteerexperiences",
	[ProfileJsonBinaryProfileType.VOLUNTEERCAUSES]: "Volunteercauses",
	[ProfileJsonBinaryProfileType.PUBLICATIONS]: "Publications",
	[ProfileJsonBinaryProfileType.POSITIONGROUPS]: "Positiongroups",
	[ProfileJsonBinaryProfileType.BROWSEMAPWITHDISTANCE]: "Browsemapwithdistance",
	[ProfileJsonBinaryProfileType.TALENTRECIPIENTINMAILCOSTINFO]: "Talentrecipientinmailcostinfo",
	[ProfileJsonBinaryProfileType.INTERESTS]: "Interests",
	[ProfileJsonBinaryProfileType.GROUPLISTINGPAGE]: "Grouplistingpage",
	[ProfileJsonBinaryProfileType.COMPANY]: "Company",
	[ProfileJsonBinaryProfileType.SEARCH]: "Search",
	[ProfileJsonBinaryProfileType.JOB_SEARCH]: "Job Search",
	[ProfileJsonBinaryProfileType.JOB]: "Job",
	[ProfileJsonBinaryProfileType.HIRING]: "Hiring",
	[ProfileJsonBinaryProfileType.GEOSEARCHTYPE]: "Geosearchtype",
	[ProfileJsonBinaryProfileType.DASH_PROFILE]: "Dash Profile",
	[ProfileJsonBinaryProfileType.PROFILE_TNG]: "Profile Tng",
	[ProfileJsonBinaryProfileType.PROFILE_IDENTITY_FROM_DEFERRED_CARDS]: "Profile Identity From Deferred Cards",
	[ProfileJsonBinaryProfileType.PROFILE_INITIAL_CARDS_GRAPHQL]: "Profile Initial Cards (GraphQL)",
	[ProfileJsonBinaryProfileType.PROFILE_DEFERRED_CARDS_GRAPHQL]: "Profile Deferred Cards (GraphQL)",
	[ProfileJsonBinaryProfileType.DASH_PROFILE_GRAPHQL]: "Dash Profile Core (GraphQL)",
	[ProfileJsonBinaryProfileType.DASH_PROFILE_SUPPLEMENTARY_GRAPHQL]: "Dash Profile Supplementary (GraphQL)",
	[ProfileJsonBinaryProfileType.PROFILE_RIGHT_RAIL_CARDS_GRAPHQL]: "Profile Right Rail Cards (GraphQL)",
	[ProfileJsonBinaryProfileType.PROFILE_HTML]: "Profile HTML Page",
	[ProfileJsonBinaryProfileType.EXPERIENCE_GRAPHQL]: "Experience (GraphQL)",
	[ProfileJsonBinaryProfileType.EDUCATION_GRAPHQL]: "Education (GraphQL)",
	[ProfileJsonBinaryProfileType.SKILLS_GRAPHQL]: "Skills (GraphQL)",
	[ProfileJsonBinaryProfileType.LANGUAGES_GRAPHQL]: "Languages (GraphQL)",
	[ProfileJsonBinaryProfileType.CERTIFICATIONS_GRAPHQL]: "Certifications (GraphQL)",
	[ProfileJsonBinaryProfileType.VOLUNTEERING_GRAPHQL]: "Volunteering (GraphQL)",
	[ProfileJsonBinaryProfileType.RECOMMENDATIONS_GRAPHQL]: "Recommendations (GraphQL)",
	[ProfileJsonBinaryProfileType.PROJECTS_GRAPHQL]: "Projects (GraphQL)",
	[ProfileJsonBinaryProfileType.PUBLICATIONS_GRAPHQL]: "Publications (GraphQL)",
	[ProfileJsonBinaryProfileType.HONORS_AWARDS_GRAPHQL]: "Honors & Awards (GraphQL)",
	[ProfileJsonBinaryProfileType.PATENTS_GRAPHQL]: "Patents (GraphQL)",
	[ProfileJsonBinaryProfileType.COURSES_GRAPHQL]: "Courses (GraphQL)",
	[ProfileJsonBinaryProfileType.ORGANIZATIONS_GRAPHQL]: "Organizations (GraphQL)",
	[ProfileJsonBinaryProfileType.GROUPS_GRAPHQL]: "Groups (GraphQL)",
	[ProfileJsonBinaryProfileType.NETWORK_PROXIMITY_GRAPHQL]: "Network Proximity (GraphQL)",
	[ProfileJsonBinaryProfileType.INTERESTS_GRAPHQL]: "Interests (GraphQL)",
	[ProfileJsonBinaryProfileType.VOYAGERMESSAGINGDASHCOMPOSEOPTIONS]: "Voyager Messaging Compose Options",
	[ProfileJsonBinaryProfileType.CONTACTINFO_TNG]: "Contact Info (GraphQL)",
	[ProfileJsonBinaryProfileType.CONVERSATIONS]: "Conversations",
	[ProfileJsonBinaryProfileType.CONVERSATION_MESSAGES]: "Conversation Messages",
	[ProfileJsonBinaryProfileType.INVITATIONS]: "Invitations",
	[ProfileJsonBinaryProfileType.CONVERSATIONS_GRAPHQL]: "Conversations (GraphQL)",
	[ProfileJsonBinaryProfileType.CONVERSATION_MESSAGES_GRAPHQL]: "Conversation Messages (GraphQL)",
	[ProfileJsonBinaryProfileType.TALENT_CONVERSATION]: "Talent Conversation",
	[ProfileJsonBinaryProfileType.TALENT_SEARCH]: "Talent Search",
	[ProfileJsonBinaryProfileType.TALENT_MAILBOX]: "Talent Mailbox Summary",
	[ProfileJsonBinaryProfileType.GROUP_MEMBERSHIPS]: "Group Memberships",
	[ProfileJsonBinaryProfileType.CURATED_CONTACTS]: "Curated Contacts",
	[ProfileJsonBinaryProfileType.AERO_STATIC]: "Aero Static Asset",
	[ProfileJsonBinaryProfileType.ME]: "Me (Identity)",
	[ProfileJsonBinaryProfileType.IWE_RESTRICTION]: "IWE Restriction",
	[ProfileJsonBinaryProfileType.FLAGSHIP_WEB]: "Flagship Web",
	[ProfileJsonBinaryProfileType.LINKEDIN_HOMEPAGE]: "LinkedIn Homepage",
	[ProfileJsonBinaryProfileType.LITMS]: "LITMS Metadata",
	[ProfileJsonBinaryProfileType.RECOMMENDATIONS]: "Recommendations",
	[ProfileJsonBinaryProfileType.ME_PROFILE]: "Me (Profile)",
	[ProfileJsonBinaryProfileType.SKILLS_RSC]: "Skills (SDUI pager, RSC)",
	[ProfileJsonBinaryProfileType.EXPERIENCE_RSC]: "Experience (SDUI pager, RSC)",
	[ProfileJsonBinaryProfileType.EDUCATION_RSC]: "Education (SDUI pager, RSC)",
	[ProfileJsonBinaryProfileType.RECOMMENDATIONS_RSC]: "Recommendations (SDUI pager, RSC)",
	[ProfileJsonBinaryProfileType.PROJECTS_RSC]: "Projects (SDUI pager, RSC)",
	[ProfileJsonBinaryProfileType.PUBLICATIONS_RSC]: "Publications (SDUI pager, RSC)",
	[ProfileJsonBinaryProfileType.HONORS_AWARDS_RSC]: "Honors & Awards (SDUI pager, RSC)",
	[ProfileJsonBinaryProfileType.COURSES_RSC]: "Courses (SDUI pager, RSC)",
	[ProfileJsonBinaryProfileType.GROUPS_RSC]: "Groups (SDUI interests pager, RSC)",
	[ProfileJsonBinaryProfileType.PATENTS_RSC]: "Patents (SDUI pager, RSC)",
	[ProfileJsonBinaryProfileType.SKILL_ASSOCIATIONS_RSC]: "Skills of a position or project (SDUI skills modal, RSC)",
	[ProfileJsonBinaryProfileType.VOLUNTEERING_RSC]: "Volunteering (SDUI pager, RSC)",
	[ProfileJsonBinaryProfileType.LANGUAGES_RSC]: "Languages (SDUI pager, RSC)",
	[ProfileJsonBinaryProfileType.ORGANIZATIONS_RSC]: "Organizations (SDUI pager, RSC)",
	[ProfileJsonBinaryProfileType.CERTIFICATIONS_RSC]: "Certifications (SDUI pager, RSC)",
	[ProfileJsonBinaryProfileType.RECOMMENDATIONS_GIVEN_RSC]: "Recommendations given (SDUI pager, RSC)",
	[ProfileJsonBinaryProfileType.PROFILE_DOCUMENT_RSC]: "Profile document flight rows (top card, RSC)",
	[ProfileJsonBinaryProfileType.PROFILE_CARDS_RSC]: "Profile cards component (SDUI, RSC)",
	[ProfileJsonBinaryProfileType.PROFILE_ACTIVITY_RSC]: "Profile Activity card component (SDUI, RSC)",
	[ProfileJsonBinaryProfileType.BROWSEMAP_RSC]: "More profiles for you component (SDUI, RSC)",
	[ProfileJsonBinaryProfileType.COMPANY_PAGE]: "Company page (HTML embedded JSON)",
};

export const ProfileJsonBinaryProfileTypeChoices = [
	{ value: ProfileJsonBinaryProfileType.PROFILE, label: "Profile" },
	{ value: ProfileJsonBinaryProfileType.SKILLS, label: "Skills" },
	{ value: ProfileJsonBinaryProfileType.CONNECTIONS, label: "Connections" },
	{ value: ProfileJsonBinaryProfileType.CONTACTINFO, label: "Contactinfo" },
	{ value: ProfileJsonBinaryProfileType.SKILLS_CATEGORY, label: "Skills Category" },
	{ value: ProfileJsonBinaryProfileType.POSITIONS, label: "Positions" },
	{ value: ProfileJsonBinaryProfileType.PATENTS, label: "Patents" },
	{ value: ProfileJsonBinaryProfileType.EDUCATIONS, label: "Educations" },
	{ value: ProfileJsonBinaryProfileType.ORGANIZATIONS, label: "Organizations" },
	{ value: ProfileJsonBinaryProfileType.PROJECTS, label: "Projects" },
	{ value: ProfileJsonBinaryProfileType.LANGUAGES, label: "Languages" },
	{ value: ProfileJsonBinaryProfileType.CERTIFICATIONS, label: "Certifications" },
	{ value: ProfileJsonBinaryProfileType.COURSES, label: "Courses" },
	{ value: ProfileJsonBinaryProfileType.HONORS, label: "Honors" },
	{ value: ProfileJsonBinaryProfileType.VOLUNTEEREXPERIENCES, label: "Volunteerexperiences" },
	{ value: ProfileJsonBinaryProfileType.VOLUNTEERCAUSES, label: "Volunteercauses" },
	{ value: ProfileJsonBinaryProfileType.PUBLICATIONS, label: "Publications" },
	{ value: ProfileJsonBinaryProfileType.POSITIONGROUPS, label: "Positiongroups" },
	{ value: ProfileJsonBinaryProfileType.BROWSEMAPWITHDISTANCE, label: "Browsemapwithdistance" },
	{ value: ProfileJsonBinaryProfileType.TALENTRECIPIENTINMAILCOSTINFO, label: "Talentrecipientinmailcostinfo" },
	{ value: ProfileJsonBinaryProfileType.INTERESTS, label: "Interests" },
	{ value: ProfileJsonBinaryProfileType.GROUPLISTINGPAGE, label: "Grouplistingpage" },
	{ value: ProfileJsonBinaryProfileType.COMPANY, label: "Company" },
	{ value: ProfileJsonBinaryProfileType.SEARCH, label: "Search" },
	{ value: ProfileJsonBinaryProfileType.JOB_SEARCH, label: "Job Search" },
	{ value: ProfileJsonBinaryProfileType.JOB, label: "Job" },
	{ value: ProfileJsonBinaryProfileType.HIRING, label: "Hiring" },
	{ value: ProfileJsonBinaryProfileType.GEOSEARCHTYPE, label: "Geosearchtype" },
	{ value: ProfileJsonBinaryProfileType.DASH_PROFILE, label: "Dash Profile" },
	{ value: ProfileJsonBinaryProfileType.PROFILE_TNG, label: "Profile Tng" },
	{ value: ProfileJsonBinaryProfileType.PROFILE_IDENTITY_FROM_DEFERRED_CARDS, label: "Profile Identity From Deferred Cards" },
	{ value: ProfileJsonBinaryProfileType.PROFILE_INITIAL_CARDS_GRAPHQL, label: "Profile Initial Cards (GraphQL)" },
	{ value: ProfileJsonBinaryProfileType.PROFILE_DEFERRED_CARDS_GRAPHQL, label: "Profile Deferred Cards (GraphQL)" },
	{ value: ProfileJsonBinaryProfileType.DASH_PROFILE_GRAPHQL, label: "Dash Profile Core (GraphQL)" },
	{ value: ProfileJsonBinaryProfileType.DASH_PROFILE_SUPPLEMENTARY_GRAPHQL, label: "Dash Profile Supplementary (GraphQL)" },
	{ value: ProfileJsonBinaryProfileType.PROFILE_RIGHT_RAIL_CARDS_GRAPHQL, label: "Profile Right Rail Cards (GraphQL)" },
	{ value: ProfileJsonBinaryProfileType.PROFILE_HTML, label: "Profile HTML Page" },
	{ value: ProfileJsonBinaryProfileType.EXPERIENCE_GRAPHQL, label: "Experience (GraphQL)" },
	{ value: ProfileJsonBinaryProfileType.EDUCATION_GRAPHQL, label: "Education (GraphQL)" },
	{ value: ProfileJsonBinaryProfileType.SKILLS_GRAPHQL, label: "Skills (GraphQL)" },
	{ value: ProfileJsonBinaryProfileType.LANGUAGES_GRAPHQL, label: "Languages (GraphQL)" },
	{ value: ProfileJsonBinaryProfileType.CERTIFICATIONS_GRAPHQL, label: "Certifications (GraphQL)" },
	{ value: ProfileJsonBinaryProfileType.VOLUNTEERING_GRAPHQL, label: "Volunteering (GraphQL)" },
	{ value: ProfileJsonBinaryProfileType.RECOMMENDATIONS_GRAPHQL, label: "Recommendations (GraphQL)" },
	{ value: ProfileJsonBinaryProfileType.PROJECTS_GRAPHQL, label: "Projects (GraphQL)" },
	{ value: ProfileJsonBinaryProfileType.PUBLICATIONS_GRAPHQL, label: "Publications (GraphQL)" },
	{ value: ProfileJsonBinaryProfileType.HONORS_AWARDS_GRAPHQL, label: "Honors & Awards (GraphQL)" },
	{ value: ProfileJsonBinaryProfileType.PATENTS_GRAPHQL, label: "Patents (GraphQL)" },
	{ value: ProfileJsonBinaryProfileType.COURSES_GRAPHQL, label: "Courses (GraphQL)" },
	{ value: ProfileJsonBinaryProfileType.ORGANIZATIONS_GRAPHQL, label: "Organizations (GraphQL)" },
	{ value: ProfileJsonBinaryProfileType.GROUPS_GRAPHQL, label: "Groups (GraphQL)" },
	{ value: ProfileJsonBinaryProfileType.NETWORK_PROXIMITY_GRAPHQL, label: "Network Proximity (GraphQL)" },
	{ value: ProfileJsonBinaryProfileType.INTERESTS_GRAPHQL, label: "Interests (GraphQL)" },
	{ value: ProfileJsonBinaryProfileType.VOYAGERMESSAGINGDASHCOMPOSEOPTIONS, label: "Voyager Messaging Compose Options" },
	{ value: ProfileJsonBinaryProfileType.CONTACTINFO_TNG, label: "Contact Info (GraphQL)" },
	{ value: ProfileJsonBinaryProfileType.CONVERSATIONS, label: "Conversations" },
	{ value: ProfileJsonBinaryProfileType.CONVERSATION_MESSAGES, label: "Conversation Messages" },
	{ value: ProfileJsonBinaryProfileType.INVITATIONS, label: "Invitations" },
	{ value: ProfileJsonBinaryProfileType.CONVERSATIONS_GRAPHQL, label: "Conversations (GraphQL)" },
	{ value: ProfileJsonBinaryProfileType.CONVERSATION_MESSAGES_GRAPHQL, label: "Conversation Messages (GraphQL)" },
	{ value: ProfileJsonBinaryProfileType.TALENT_CONVERSATION, label: "Talent Conversation" },
	{ value: ProfileJsonBinaryProfileType.TALENT_SEARCH, label: "Talent Search" },
	{ value: ProfileJsonBinaryProfileType.TALENT_MAILBOX, label: "Talent Mailbox Summary" },
	{ value: ProfileJsonBinaryProfileType.GROUP_MEMBERSHIPS, label: "Group Memberships" },
	{ value: ProfileJsonBinaryProfileType.CURATED_CONTACTS, label: "Curated Contacts" },
	{ value: ProfileJsonBinaryProfileType.AERO_STATIC, label: "Aero Static Asset" },
	{ value: ProfileJsonBinaryProfileType.ME, label: "Me (Identity)" },
	{ value: ProfileJsonBinaryProfileType.IWE_RESTRICTION, label: "IWE Restriction" },
	{ value: ProfileJsonBinaryProfileType.FLAGSHIP_WEB, label: "Flagship Web" },
	{ value: ProfileJsonBinaryProfileType.LINKEDIN_HOMEPAGE, label: "LinkedIn Homepage" },
	{ value: ProfileJsonBinaryProfileType.LITMS, label: "LITMS Metadata" },
	{ value: ProfileJsonBinaryProfileType.RECOMMENDATIONS, label: "Recommendations" },
	{ value: ProfileJsonBinaryProfileType.ME_PROFILE, label: "Me (Profile)" },
	{ value: ProfileJsonBinaryProfileType.SKILLS_RSC, label: "Skills (SDUI pager, RSC)" },
	{ value: ProfileJsonBinaryProfileType.EXPERIENCE_RSC, label: "Experience (SDUI pager, RSC)" },
	{ value: ProfileJsonBinaryProfileType.EDUCATION_RSC, label: "Education (SDUI pager, RSC)" },
	{ value: ProfileJsonBinaryProfileType.RECOMMENDATIONS_RSC, label: "Recommendations (SDUI pager, RSC)" },
	{ value: ProfileJsonBinaryProfileType.PROJECTS_RSC, label: "Projects (SDUI pager, RSC)" },
	{ value: ProfileJsonBinaryProfileType.PUBLICATIONS_RSC, label: "Publications (SDUI pager, RSC)" },
	{ value: ProfileJsonBinaryProfileType.HONORS_AWARDS_RSC, label: "Honors & Awards (SDUI pager, RSC)" },
	{ value: ProfileJsonBinaryProfileType.COURSES_RSC, label: "Courses (SDUI pager, RSC)" },
	{ value: ProfileJsonBinaryProfileType.GROUPS_RSC, label: "Groups (SDUI interests pager, RSC)" },
	{ value: ProfileJsonBinaryProfileType.PATENTS_RSC, label: "Patents (SDUI pager, RSC)" },
	{ value: ProfileJsonBinaryProfileType.SKILL_ASSOCIATIONS_RSC, label: "Skills of a position or project (SDUI skills modal, RSC)" },
	{ value: ProfileJsonBinaryProfileType.VOLUNTEERING_RSC, label: "Volunteering (SDUI pager, RSC)" },
	{ value: ProfileJsonBinaryProfileType.LANGUAGES_RSC, label: "Languages (SDUI pager, RSC)" },
	{ value: ProfileJsonBinaryProfileType.ORGANIZATIONS_RSC, label: "Organizations (SDUI pager, RSC)" },
	{ value: ProfileJsonBinaryProfileType.CERTIFICATIONS_RSC, label: "Certifications (SDUI pager, RSC)" },
	{ value: ProfileJsonBinaryProfileType.RECOMMENDATIONS_GIVEN_RSC, label: "Recommendations given (SDUI pager, RSC)" },
	{ value: ProfileJsonBinaryProfileType.PROFILE_DOCUMENT_RSC, label: "Profile document flight rows (top card, RSC)" },
	{ value: ProfileJsonBinaryProfileType.PROFILE_CARDS_RSC, label: "Profile cards component (SDUI, RSC)" },
	{ value: ProfileJsonBinaryProfileType.PROFILE_ACTIVITY_RSC, label: "Profile Activity card component (SDUI, RSC)" },
	{ value: ProfileJsonBinaryProfileType.BROWSEMAP_RSC, label: "More profiles for you component (SDUI, RSC)" },
	{ value: ProfileJsonBinaryProfileType.COMPANY_PAGE, label: "Company page (HTML embedded JSON)" },
] as const;

/** core.models.reminder.Reminder.ReminderStates */
export enum ReminderStates {
	ACTIVE = 0,
	ACTIVE_SNOOZED = 1,
	DONE = 2,
	DELETED = 3,
}

export const ReminderStatesLabels: Record<ReminderStates, string> = {
	[ReminderStates.ACTIVE]: "Active",
	[ReminderStates.ACTIVE_SNOOZED]: "Active Snoozed",
	[ReminderStates.DONE]: "Done",
	[ReminderStates.DELETED]: "Deleted",
};

export const ReminderStatesChoices = [
	{ value: ReminderStates.ACTIVE, label: "Active" },
	{ value: ReminderStates.ACTIVE_SNOOZED, label: "Active Snoozed" },
	{ value: ReminderStates.DONE, label: "Done" },
	{ value: ReminderStates.DELETED, label: "Deleted" },
] as const;

/** core.models.send_invitations_queue.InviteTier */
export enum InviteTier {
	EGENKONSULTER_ACTIVE = "assignments_egenkonsulter_active",
	EGENKONSULTER = "assignments_egenkonsulter",
	ASSIGNMENTS = "assignments",
	SAME_GROUP = "assignments_same_g",
	ACTIVE = "assignments_active",
	INACTIVE = "assignments_inactive",
}

export const InviteTierLabels: Record<InviteTier, string> = {
	[InviteTier.EGENKONSULTER_ACTIVE]: "Active egenkonsult role",
	[InviteTier.EGENKONSULTER]: "Inactive egenkonsult role",
	[InviteTier.ASSIGNMENTS]: "Own active role",
	[InviteTier.SAME_GROUP]: "Colleague's active role",
	[InviteTier.ACTIVE]: "Other active role",
	[InviteTier.INACTIVE]: "Inactive role",
};

export const InviteTierChoices = [
	{ value: InviteTier.EGENKONSULTER_ACTIVE, label: "Active egenkonsult role" },
	{ value: InviteTier.EGENKONSULTER, label: "Inactive egenkonsult role" },
	{ value: InviteTier.ASSIGNMENTS, label: "Own active role" },
	{ value: InviteTier.SAME_GROUP, label: "Colleague's active role" },
	{ value: InviteTier.ACTIVE, label: "Other active role" },
	{ value: InviteTier.INACTIVE, label: "Inactive role" },
] as const;

/** core.models.send_linkedin_message.SendLinkedinMessageQueue.MessageType */
export enum SendLinkedinMessageQueueMessageType {
	MESSAGE = 0,
	RECRUITER_FREE_INMAIL = 1,
	PAID_INMAIL = 2,
	GROUP_MESSAGE = 3,
	EMAIL = 4,
	INVITE = 5,
	SMS = 6,
}

export const SendLinkedinMessageQueueMessageTypeLabels: Record<SendLinkedinMessageQueueMessageType, string> = {
	[SendLinkedinMessageQueueMessageType.MESSAGE]: "Message",
	[SendLinkedinMessageQueueMessageType.RECRUITER_FREE_INMAIL]: "Recruiter Free Inmail",
	[SendLinkedinMessageQueueMessageType.PAID_INMAIL]: "Paid Inmail",
	[SendLinkedinMessageQueueMessageType.GROUP_MESSAGE]: "Group Message",
	[SendLinkedinMessageQueueMessageType.EMAIL]: "Email",
	[SendLinkedinMessageQueueMessageType.INVITE]: "Invite",
	[SendLinkedinMessageQueueMessageType.SMS]: "Sms",
};

export const SendLinkedinMessageQueueMessageTypeChoices = [
	{ value: SendLinkedinMessageQueueMessageType.MESSAGE, label: "Message" },
	{ value: SendLinkedinMessageQueueMessageType.RECRUITER_FREE_INMAIL, label: "Recruiter Free Inmail" },
	{ value: SendLinkedinMessageQueueMessageType.PAID_INMAIL, label: "Paid Inmail" },
	{ value: SendLinkedinMessageQueueMessageType.GROUP_MESSAGE, label: "Group Message" },
	{ value: SendLinkedinMessageQueueMessageType.EMAIL, label: "Email" },
	{ value: SendLinkedinMessageQueueMessageType.INVITE, label: "Invite" },
	{ value: SendLinkedinMessageQueueMessageType.SMS, label: "Sms" },
] as const;

/** core.models.ses_delivery_event.SesDeliveryEvent.Status */
export enum SesDeliveryEventStatus {
	SENT = 1,
	DELIVERED = 2,
	BOUNCED = 3,
	COMPLAINT = 4,
}

export const SesDeliveryEventStatusLabels: Record<SesDeliveryEventStatus, string> = {
	[SesDeliveryEventStatus.SENT]: "sent",
	[SesDeliveryEventStatus.DELIVERED]: "delivered",
	[SesDeliveryEventStatus.BOUNCED]: "bounced",
	[SesDeliveryEventStatus.COMPLAINT]: "complaint",
};

export const SesDeliveryEventStatusChoices = [
	{ value: SesDeliveryEventStatus.SENT, label: "sent" },
	{ value: SesDeliveryEventStatus.DELIVERED, label: "delivered" },
	{ value: SesDeliveryEventStatus.BOUNCED, label: "bounced" },
	{ value: SesDeliveryEventStatus.COMPLAINT, label: "complaint" },
] as const;

/** core.models.sign_in_identity.SignInProvider */
export enum SignInProvider {
	GOOGLE = "google",
	MICROSOFT = "microsoft",
}

export const SignInProviderLabels: Record<SignInProvider, string> = {
	[SignInProvider.GOOGLE]: "Google",
	[SignInProvider.MICROSOFT]: "Microsoft",
};

export const SignInProviderChoices = [
	{ value: SignInProvider.GOOGLE, label: "Google" },
	{ value: SignInProvider.MICROSOFT, label: "Microsoft" },
] as const;

/** core.models.sms_provider_queue.SmsProviderQueue.Direction */
export enum SmsProviderQueueDirection {
	INCOMING = 0,
	OUTGOING = 1,
}

export const SmsProviderQueueDirectionLabels: Record<SmsProviderQueueDirection, string> = {
	[SmsProviderQueueDirection.INCOMING]: "Incoming",
	[SmsProviderQueueDirection.OUTGOING]: "Outgoing",
};

export const SmsProviderQueueDirectionChoices = [
	{ value: SmsProviderQueueDirection.INCOMING, label: "Incoming" },
	{ value: SmsProviderQueueDirection.OUTGOING, label: "Outgoing" },
] as const;

/** core.models.sms_provider_queue.SmsProviderQueue.MessageStatus */
export enum SmsProviderQueueMessageStatus {
	CREATED = 0,
	SENT = 1,
	DELIVERED = 2,
	FAILED = 3,
}

export const SmsProviderQueueMessageStatusLabels: Record<SmsProviderQueueMessageStatus, string> = {
	[SmsProviderQueueMessageStatus.CREATED]: "Created",
	[SmsProviderQueueMessageStatus.SENT]: "Sent",
	[SmsProviderQueueMessageStatus.DELIVERED]: "Delivered",
	[SmsProviderQueueMessageStatus.FAILED]: "Failed",
};

export const SmsProviderQueueMessageStatusChoices = [
	{ value: SmsProviderQueueMessageStatus.CREATED, label: "Created" },
	{ value: SmsProviderQueueMessageStatus.SENT, label: "Sent" },
	{ value: SmsProviderQueueMessageStatus.DELIVERED, label: "Delivered" },
	{ value: SmsProviderQueueMessageStatus.FAILED, label: "Failed" },
] as const;

/** core.models.stored_blob.BlobReplica.State */
export enum BlobReplicaState {
	PENDING = "pending",
	VERIFIED = "verified",
	FAILED = "failed",
}

export const BlobReplicaStateLabels: Record<BlobReplicaState, string> = {
	[BlobReplicaState.PENDING]: "Pending",
	[BlobReplicaState.VERIFIED]: "Verified",
	[BlobReplicaState.FAILED]: "Failed",
};

export const BlobReplicaStateChoices = [
	{ value: BlobReplicaState.PENDING, label: "Pending" },
	{ value: BlobReplicaState.VERIFIED, label: "Verified" },
	{ value: BlobReplicaState.FAILED, label: "Failed" },
] as const;

/** core.models.stored_blob.StorageLocation.Provider */
export enum StorageLocationProvider {
	HETZNER = "hz",
	GCS = "gcs",
	BACKBLAZE = "b2",
	LOCAL = "local",
}

export const StorageLocationProviderLabels: Record<StorageLocationProvider, string> = {
	[StorageLocationProvider.HETZNER]: "Hetzner S3",
	[StorageLocationProvider.GCS]: "Google Cloud Storage",
	[StorageLocationProvider.BACKBLAZE]: "Backblaze B2",
	[StorageLocationProvider.LOCAL]: "Local directory",
};

export const StorageLocationProviderChoices = [
	{ value: StorageLocationProvider.HETZNER, label: "Hetzner S3" },
	{ value: StorageLocationProvider.GCS, label: "Google Cloud Storage" },
	{ value: StorageLocationProvider.BACKBLAZE, label: "Backblaze B2" },
	{ value: StorageLocationProvider.LOCAL, label: "Local directory" },
] as const;

/** core.models.support_research.SupportResearchTurnState */
export enum SupportResearchTurnState {
	PENDING = "pending",
	DONE = "done",
}

export const SupportResearchTurnStateLabels: Record<SupportResearchTurnState, string> = {
	[SupportResearchTurnState.PENDING]: "Asking",
	[SupportResearchTurnState.DONE]: "Answered",
};

export const SupportResearchTurnStateChoices = [
	{ value: SupportResearchTurnState.PENDING, label: "Asking" },
	{ value: SupportResearchTurnState.DONE, label: "Answered" },
] as const;

/** core.models.support_ticket.SupportAiSuggestionState */
export enum SupportAiSuggestionState {
	PENDING = "pending",
	DONE = "done",
}

export const SupportAiSuggestionStateLabels: Record<SupportAiSuggestionState, string> = {
	[SupportAiSuggestionState.PENDING]: "Drafting",
	[SupportAiSuggestionState.DONE]: "Done",
};

export const SupportAiSuggestionStateChoices = [
	{ value: SupportAiSuggestionState.PENDING, label: "Drafting" },
	{ value: SupportAiSuggestionState.DONE, label: "Done" },
] as const;

/** core.models.support_ticket.SupportTicketStatus */
export enum SupportTicketStatus {
	NEW = "new",
	WAITING_ON_SUPPORT = "waiting_on_support",
	WAITING_ON_USER = "waiting_on_user",
	STALLED = "stalled",
	ENDED_BY_REPORTER = "ended_by_reporter",
	RESOLVED = "resolved",
}

export const SupportTicketStatusLabels: Record<SupportTicketStatus, string> = {
	[SupportTicketStatus.NEW]: "New",
	[SupportTicketStatus.WAITING_ON_SUPPORT]: "Waiting for support",
	[SupportTicketStatus.WAITING_ON_USER]: "Waiting for customer",
	[SupportTicketStatus.STALLED]: "Stalled",
	[SupportTicketStatus.ENDED_BY_REPORTER]: "Ended by reporter",
	[SupportTicketStatus.RESOLVED]: "Closed",
};

export const SupportTicketStatusChoices = [
	{ value: SupportTicketStatus.NEW, label: "New" },
	{ value: SupportTicketStatus.WAITING_ON_SUPPORT, label: "Waiting for support" },
	{ value: SupportTicketStatus.WAITING_ON_USER, label: "Waiting for customer" },
	{ value: SupportTicketStatus.STALLED, label: "Stalled" },
	{ value: SupportTicketStatus.ENDED_BY_REPORTER, label: "Ended by reporter" },
	{ value: SupportTicketStatus.RESOLVED, label: "Closed" },
] as const;

/** core.models.system_settings.SystemSettings.MlRankingBackend */
export enum SystemSettingsMlRankingBackend {
	BIGQUERY = "bigquery",
	LOCAL = "local",
}

export const SystemSettingsMlRankingBackendLabels: Record<SystemSettingsMlRankingBackend, string> = {
	[SystemSettingsMlRankingBackend.BIGQUERY]: "BigQuery",
	[SystemSettingsMlRankingBackend.LOCAL]: "In-house",
};

export const SystemSettingsMlRankingBackendChoices = [
	{ value: SystemSettingsMlRankingBackend.BIGQUERY, label: "BigQuery" },
	{ value: SystemSettingsMlRankingBackend.LOCAL, label: "In-house" },
] as const;

/** core.models.user_profile.UserProfile.EmailMethod */
export enum UserProfileEmailMethod {
	IMAP = 1,
	OUTLOOK = 2,
	GMAIL = 3,
	HOSTED = 4,
}

export const UserProfileEmailMethodLabels: Record<UserProfileEmailMethod, string> = {
	[UserProfileEmailMethod.IMAP]: "IMAP",
	[UserProfileEmailMethod.OUTLOOK]: "Outlook",
	[UserProfileEmailMethod.GMAIL]: "Gmail",
	[UserProfileEmailMethod.HOSTED]: "Hosted",
};

export const UserProfileEmailMethodChoices = [
	{ value: UserProfileEmailMethod.IMAP, label: "IMAP" },
	{ value: UserProfileEmailMethod.OUTLOOK, label: "Outlook" },
	{ value: UserProfileEmailMethod.GMAIL, label: "Gmail" },
	{ value: UserProfileEmailMethod.HOSTED, label: "Hosted" },
] as const;

/** core.models.voyager_log.VoyagerLog.CallerType */
export enum VoyagerLogCallerType {
	LINKEDIN_API = 1,
	SELENIUM = 2,
	REQUEST_POST = 3,
	REQUEST = 4,
	REQUEST_GET = 5,
	REQUESTS = 6,
	CHROME_PLUGIN = 7,
	PYDOLL = 8,
}

export const VoyagerLogCallerTypeLabels: Record<VoyagerLogCallerType, string> = {
	[VoyagerLogCallerType.LINKEDIN_API]: "Linkedin Api",
	[VoyagerLogCallerType.SELENIUM]: "Selenium",
	[VoyagerLogCallerType.REQUEST_POST]: "Request Post",
	[VoyagerLogCallerType.REQUEST]: "Request",
	[VoyagerLogCallerType.REQUEST_GET]: "Request Get",
	[VoyagerLogCallerType.REQUESTS]: "Requests",
	[VoyagerLogCallerType.CHROME_PLUGIN]: "Artemis Helper",
	[VoyagerLogCallerType.PYDOLL]: "Pydoll",
};

export const VoyagerLogCallerTypeChoices = [
	{ value: VoyagerLogCallerType.LINKEDIN_API, label: "Linkedin Api" },
	{ value: VoyagerLogCallerType.SELENIUM, label: "Selenium" },
	{ value: VoyagerLogCallerType.REQUEST_POST, label: "Request Post" },
	{ value: VoyagerLogCallerType.REQUEST, label: "Request" },
	{ value: VoyagerLogCallerType.REQUEST_GET, label: "Request Get" },
	{ value: VoyagerLogCallerType.REQUESTS, label: "Requests" },
	{ value: VoyagerLogCallerType.CHROME_PLUGIN, label: "Artemis Helper" },
	{ value: VoyagerLogCallerType.PYDOLL, label: "Pydoll" },
] as const;

/** core.models.worker_slot.WorkerSlot.State */
export enum WorkerSlotState {
	IDLE = "idle",
	DISPATCHING = "dispatching",
	PROCESSING = "processing",
	COMPLETING = "completing",
}

export const WorkerSlotStateLabels: Record<WorkerSlotState, string> = {
	[WorkerSlotState.IDLE]: "Idle",
	[WorkerSlotState.DISPATCHING]: "Dispatching",
	[WorkerSlotState.PROCESSING]: "Processing",
	[WorkerSlotState.COMPLETING]: "Completing",
};

export const WorkerSlotStateChoices = [
	{ value: WorkerSlotState.IDLE, label: "Idle" },
	{ value: WorkerSlotState.DISPATCHING, label: "Dispatching" },
	{ value: WorkerSlotState.PROCESSING, label: "Processing" },
	{ value: WorkerSlotState.COMPLETING, label: "Completing" },
] as const;

/** core.models.workflow_document.WorkflowDeliveryKind */
export enum WorkflowDeliveryKind {
	DOCUMENT = "document",
	ANSWER = "answer",
	BUILD_REPORT = "build_report",
	CI_FIX = "ci_fix",
}

export const WorkflowDeliveryKindLabels: Record<WorkflowDeliveryKind, string> = {
	[WorkflowDeliveryKind.DOCUMENT]: "Stage document",
	[WorkflowDeliveryKind.ANSWER]: "Answer to feedback",
	[WorkflowDeliveryKind.BUILD_REPORT]: "Build report",
	[WorkflowDeliveryKind.CI_FIX]: "CI fix report",
};

export const WorkflowDeliveryKindChoices = [
	{ value: WorkflowDeliveryKind.DOCUMENT, label: "Stage document" },
	{ value: WorkflowDeliveryKind.ANSWER, label: "Answer to feedback" },
	{ value: WorkflowDeliveryKind.BUILD_REPORT, label: "Build report" },
	{ value: WorkflowDeliveryKind.CI_FIX, label: "CI fix report" },
] as const;

/** core.models.workflow_persona_lease.PersonaLeaseState */
export enum PersonaLeaseState {
	ACTIVE = "active",
	RELEASED = "released",
	EXPIRED = "expired",
}

export const PersonaLeaseStateLabels: Record<PersonaLeaseState, string> = {
	[PersonaLeaseState.ACTIVE]: "Held by a session",
	[PersonaLeaseState.RELEASED]: "Given back",
	[PersonaLeaseState.EXPIRED]: "Timed out",
};

export const PersonaLeaseStateChoices = [
	{ value: PersonaLeaseState.ACTIVE, label: "Held by a session" },
	{ value: PersonaLeaseState.RELEASED, label: "Given back" },
	{ value: PersonaLeaseState.EXPIRED, label: "Timed out" },
] as const;

/** core.models.workflow_release_notes.ReleaseNotesAudience */
export enum ReleaseNotesAudience {
	STAFF = "staff",
	ALL = "all",
}

export const ReleaseNotesAudienceLabels: Record<ReleaseNotesAudience, string> = {
	[ReleaseNotesAudience.STAFF]: "Staff only",
	[ReleaseNotesAudience.ALL]: "All users",
};

export const ReleaseNotesAudienceChoices = [
	{ value: ReleaseNotesAudience.STAFF, label: "Staff only" },
	{ value: ReleaseNotesAudience.ALL, label: "All users" },
] as const;

/** core.models.workflow_session_files.WorkflowUploadKind */
export enum WorkflowUploadKind {
	DOCUMENT = "document",
	DOCUMENT_PATCH = "document_patch",
	PATCH = "patch",
}

export const WorkflowUploadKindLabels: Record<WorkflowUploadKind, string> = {
	[WorkflowUploadKind.DOCUMENT]: "Document",
	[WorkflowUploadKind.DOCUMENT_PATCH]: "Document patch",
	[WorkflowUploadKind.PATCH]: "Patch",
};

export const WorkflowUploadKindChoices = [
	{ value: WorkflowUploadKind.DOCUMENT, label: "Document" },
	{ value: WorkflowUploadKind.DOCUMENT_PATCH, label: "Document patch" },
	{ value: WorkflowUploadKind.PATCH, label: "Patch" },
] as const;

/** core.models.workflow_stage.WorkflowCiStatus */
export enum WorkflowCiStatus {
	PENDING = "pending",
	SUCCESS = "success",
	FAILURE = "failure",
}

export const WorkflowCiStatusLabels: Record<WorkflowCiStatus, string> = {
	[WorkflowCiStatus.PENDING]: "Running",
	[WorkflowCiStatus.SUCCESS]: "Green",
	[WorkflowCiStatus.FAILURE]: "Red",
};

export const WorkflowCiStatusChoices = [
	{ value: WorkflowCiStatus.PENDING, label: "Running" },
	{ value: WorkflowCiStatus.SUCCESS, label: "Green" },
	{ value: WorkflowCiStatus.FAILURE, label: "Red" },
] as const;

/** core.models.workflow_stage.WorkflowMergeState */
export enum WorkflowMergeState {
	QUEUED = "queued",
	SYNCING = "syncing",
	AWAITING_CI = "awaiting_ci",
	FIXING = "fixing",
	MERGING = "merging",
	VERIFYING = "verifying",
	DONE = "done",
	BLOCKED = "blocked",
}

export const WorkflowMergeStateLabels: Record<WorkflowMergeState, string> = {
	[WorkflowMergeState.QUEUED]: "Queued to merge",
	[WorkflowMergeState.SYNCING]: "Merging master into the branch",
	[WorkflowMergeState.AWAITING_CI]: "Waiting for CI",
	[WorkflowMergeState.FIXING]: "A session is fixing it",
	[WorkflowMergeState.MERGING]: "Merging into master",
	[WorkflowMergeState.VERIFYING]: "Checking master",
	[WorkflowMergeState.DONE]: "Merged",
	[WorkflowMergeState.BLOCKED]: "Stopped — needs a human",
};

export const WorkflowMergeStateChoices = [
	{ value: WorkflowMergeState.QUEUED, label: "Queued to merge" },
	{ value: WorkflowMergeState.SYNCING, label: "Merging master into the branch" },
	{ value: WorkflowMergeState.AWAITING_CI, label: "Waiting for CI" },
	{ value: WorkflowMergeState.FIXING, label: "A session is fixing it" },
	{ value: WorkflowMergeState.MERGING, label: "Merging into master" },
	{ value: WorkflowMergeState.VERIFYING, label: "Checking master" },
	{ value: WorkflowMergeState.DONE, label: "Merged" },
	{ value: WorkflowMergeState.BLOCKED, label: "Stopped — needs a human" },
] as const;

/** core.models.workflow_stage.WorkflowProdVerdict */
export enum WorkflowProdVerdict {
	SUCCESS = "success",
	FAIL = "fail",
	UNDETERMINED = "undetermined",
}

export const WorkflowProdVerdictLabels: Record<WorkflowProdVerdict, string> = {
	[WorkflowProdVerdict.SUCCESS]: "Succeeded on prod",
	[WorkflowProdVerdict.FAIL]: "Failed on prod",
	[WorkflowProdVerdict.UNDETERMINED]: "Undetermined on prod",
};

export const WorkflowProdVerdictChoices = [
	{ value: WorkflowProdVerdict.SUCCESS, label: "Succeeded on prod" },
	{ value: WorkflowProdVerdict.FAIL, label: "Failed on prod" },
	{ value: WorkflowProdVerdict.UNDETERMINED, label: "Undetermined on prod" },
] as const;

/** core.models.workflow_stage.WorkflowSessionModel */
export enum WorkflowSessionModel {
	OPUS = "claude-opus-5",
	SONNET = "claude-sonnet-5",
	FABLE = "claude-fable-5",
}

export const WorkflowSessionModelLabels: Record<WorkflowSessionModel, string> = {
	[WorkflowSessionModel.OPUS]: "Opus 5",
	[WorkflowSessionModel.SONNET]: "Sonnet 5",
	[WorkflowSessionModel.FABLE]: "Fable 5",
};

export const WorkflowSessionModelChoices = [
	{ value: WorkflowSessionModel.OPUS, label: "Opus 5" },
	{ value: WorkflowSessionModel.SONNET, label: "Sonnet 5" },
	{ value: WorkflowSessionModel.FABLE, label: "Fable 5" },
] as const;

/** core.models.workflow_stage.WorkflowStage */
export enum WorkflowStage {
	PROBLEM = "problem",
	ROOT_CAUSE = "root_cause",
	PLAN = "plan",
	IMPLEMENTATION = "implementation",
	DEPLOY = "deploy",
}

export const WorkflowStageLabels: Record<WorkflowStage, string> = {
	[WorkflowStage.PROBLEM]: "Problem statement",
	[WorkflowStage.ROOT_CAUSE]: "Root cause analysis",
	[WorkflowStage.PLAN]: "Plan",
	[WorkflowStage.IMPLEMENTATION]: "Implementation",
	[WorkflowStage.DEPLOY]: "Deploy",
};

export const WorkflowStageChoices = [
	{ value: WorkflowStage.PROBLEM, label: "Problem statement" },
	{ value: WorkflowStage.ROOT_CAUSE, label: "Root cause analysis" },
	{ value: WorkflowStage.PLAN, label: "Plan" },
	{ value: WorkflowStage.IMPLEMENTATION, label: "Implementation" },
	{ value: WorkflowStage.DEPLOY, label: "Deploy" },
] as const;

/** core.models.workflow_stage.WorkflowStatus */
export enum WorkflowStatus {
	IMPORTED = "imported",
	QUEUED = "queued",
	RUNNING = "running",
	REVIEW = "review",
	FEEDBACK_QUEUED = "feedback_queued",
	BUILDING = "building",
	IMPLEMENTING = "implementing",
	CI_FIXING = "ci_fixing",
	PROD_VERIFY_PENDING = "prod_verify_pending",
	SIGNED = "signed",
	ABANDONED = "abandoned",
}

export const WorkflowStatusLabels: Record<WorkflowStatus, string> = {
	[WorkflowStatus.IMPORTED]: "Imported",
	[WorkflowStatus.QUEUED]: "Queued for generation",
	[WorkflowStatus.RUNNING]: "Cloud session running",
	[WorkflowStatus.REVIEW]: "Awaiting review",
	[WorkflowStatus.FEEDBACK_QUEUED]: "Feedback queued",
	[WorkflowStatus.BUILDING]: "Writing the code",
	[WorkflowStatus.IMPLEMENTING]: "Implementation in progress",
	[WorkflowStatus.CI_FIXING]: "Fixing CI",
	[WorkflowStatus.PROD_VERIFY_PENDING]: "Waiting to verify on prod",
	[WorkflowStatus.SIGNED]: "Signed off",
	[WorkflowStatus.ABANDONED]: "Abandoned",
};

export const WorkflowStatusChoices = [
	{ value: WorkflowStatus.IMPORTED, label: "Imported" },
	{ value: WorkflowStatus.QUEUED, label: "Queued for generation" },
	{ value: WorkflowStatus.RUNNING, label: "Cloud session running" },
	{ value: WorkflowStatus.REVIEW, label: "Awaiting review" },
	{ value: WorkflowStatus.FEEDBACK_QUEUED, label: "Feedback queued" },
	{ value: WorkflowStatus.BUILDING, label: "Writing the code" },
	{ value: WorkflowStatus.IMPLEMENTING, label: "Implementation in progress" },
	{ value: WorkflowStatus.CI_FIXING, label: "Fixing CI" },
	{ value: WorkflowStatus.PROD_VERIFY_PENDING, label: "Waiting to verify on prod" },
	{ value: WorkflowStatus.SIGNED, label: "Signed off" },
	{ value: WorkflowStatus.ABANDONED, label: "Abandoned" },
] as const;

/** core.models.workflow_stage.WorkflowTicketType */
export enum WorkflowTicketType {
	UNCLASSIFIED = "unclassified",
	BUG = "bug",
	FEATURE = "feature",
}

export const WorkflowTicketTypeLabels: Record<WorkflowTicketType, string> = {
	[WorkflowTicketType.UNCLASSIFIED]: "Unclassified",
	[WorkflowTicketType.BUG]: "Bug",
	[WorkflowTicketType.FEATURE]: "Feature",
};

export const WorkflowTicketTypeChoices = [
	{ value: WorkflowTicketType.UNCLASSIFIED, label: "Unclassified" },
	{ value: WorkflowTicketType.BUG, label: "Bug" },
	{ value: WorkflowTicketType.FEATURE, label: "Feature" },
] as const;
